/*
 * Product translations for the "ar" locale.
 *
 * Split out of locales/ar.js so product pages stop shipping their copy to
 * every route in the app. Keys keep their original names minus the
 * "products_" prefix. See locales/products/index.js.
 */
export default {
  shopiing_page: {
    cover: {
      title1: "تمويل استهلاكي",
      title2: "بنسهّل حياتك",
      description: `لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك من خلال حلول
      تمويلية خالية من المتاعب وبأسهل وأسرع موافقة وأوسع شبكة تجار تغطي جميع
      المنتجات والخدمات ومنتشرة في جميع أنحاء الجمهورية.`,
    },
    outro:
      "كونتكت مش بس شركة تمويل، احنا شريكك اللي بيساعدك في تحقيق متطلباتك. بنساعدك تمتلك اللي بتحلم بيه من غير أي تعقيدات. اتصل بينا النهاردة، افتح حسابك، واستمتع بأسهل تجربة تسوق!",
    section_a: {
      title1: "فترة سداد",
      title2: "36 شهر",
      body: `إشتري كل إحتياجاتك بدون عمليات معقدة فقط برقم البطاقة و برقم موبايلك, من خلال نظام كنتكت الإلكتروني للتس الشراء و التقسيط من أكثر من 1000 منفذ بيع في جميع محافاظات الجمهورية. نظام التقسيط من كونتكت تسوق هو أفضل و أسرع طريقة لتمويل جميع مشترياتك من خلال شبكة ضخمة من المنافذ التجارية و معارض التجزئة و المتاجر الكبري و توكيلات الماركات العالمية. والذي يتيح لك حرية تحديد مبلغ الدفعة المقدمة و يقدم أنظمة التقسيط بفترات سداد تتراوح من 6 أشهر إلي 36 شهر.`,
    },
    section_b: {
      title: "ازاي تشتري وتقسط مع كونتكت؟",
      description: "لما يكون عندك حساب مفتوح مع كونتكت:",
      list: [
        "إختار التاجر من خلال شبكتنا",
        "توجه إلى المتجر مع بطاقة الرقم القومي والموبايل المسجل في الخدمة",
        "حدد مبلغ القسط وفترة السداد ",
        "هيوصلك رمز العملية من خلال رسالة نصية على موبايلك لتقديمها للتاجر",
        "هيوصلك فاتورة إلكترونية من خلال رسالة نصية على موبايلك",
      ],
    },
  },
  contact_now_page: {
    cover: {
      img: "/shopping-main.png",
      title: `التسوق للمنتجات اللي بتحبها على بعد خطوة واحدة بس!`,
      description: `اكتشف حلول تمويل شراء أونلاين أو زور أقرب  فرع لـكونتكت، وفريقنا هيبقى جاهز يساعدك في أي وقت.`,
    },
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "التسوق",
      mainImage: "/shopping-main.png",
      header: "استمتع بتجربة تسوق سلسة مع تمويل كونتكت!",
      description: "",
      paragraph2: `اشتري كل اللي نفسك فيه، من أحدث الموبايلات، التليفزيونات الكبيرة، أو حاجات البيت الأساسية، واستمتع بتجربة تمويل شراء أونلاين سهلة وسلسة. مع خطط دفع مريحة وتسهيلات الدفع من  كونتكت، هتقدر تدير مشترياتك من غير ما تضغط على ميزانيتك.
خدماتنا بتوفرلك تمويل مريح للتسوق وتقسيط المشتريات، يعني تقدر تاخد اللي محتاجه دلوقتي وتدفع على أقساط سهلة ومريحة. من أول الموافقات السريعة للشبكة الكبيرة من المتاجر والباعة الموثوقين.
`,
      buttonText: "قدم الآن",
      subtitle: "هتلاقي تجربة تمويل التسوق آمنة وسلسة ومناسبة.",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/girl_shopping.webp",
      title: "إدارة فواتيرك أسهل مع فاتورتي",
      paragraph: ` ادفع أي فاتورة جديدة بسهولة مع فاتورتي.  <a href="https://play.google.com/store/apps/details?id=eg.contact" style="color: inherit; text-decoration: underline;">حمّل التطبيق</a>، اختار فترة الدفع اللي تناسبك، واستمتع بأكتر خيارات مرنة  لتقسيط الفواتير. مع فاتورتي، هتلاقي كل حاجة أسهل وأريح في إدارة فواتيرك.`,
      list: [],
    },
    offers_steps: {
      title: "اكتشف العروض الحصرية أثناء تجربة التسوق",
      subtitle: "استمتع بعروض رائعة مع تطبيق كونتكت ناو في خطوات بسيطة:",
      steps: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-1.png",
          content: "افتح تطبيق كونتكت ناو.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-2-ar.webp",
          content: "دور على التاجر اللي تحبه أو ادخل على قسم العروض.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-3-ar.webp",
          content: "اختار العرض اللي عايزه.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-4-ar.png",
          content: "ادخل البيانات المطلوبة.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-5-ar.webp",
          content: "التاجر هيراجع كل بياناتك على البوابة بتاعته.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-6-ar.webp",
          content: "زور فرع التاجر واستنى موافقتهم.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-7.webp",
          content: "هيوصلك كود أو رسالة نصية على موبايلك.",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-8-ar.webp",
          content: "بعد ما تأكد الكود، العملية هتكتمل.",
        },
      ],
    },
    third_section: {
      title: "كونتكت: شريكك في التسوق ",
      description: `مع كونتكت، تقدر تشتري أي منتج استهلاكي نفسك فيه, سواء لاب توب، موبايل، تليفزيون، أو غيره, وتدفع بعدين من خلال خطط تقسيط مرنة وموافقة سريعة. بنوفر لك أوسع شبكة تجار في مصر علشان تلاقي كل المنتجات والخدمات اللي بتدور عليها في مكان واحد. كونتكت مش مجرد شركة تمويل، إحنا شريك بيسهّل عليك تحقق احتياجاتك من غير توتر. افتح حسابك دلوقتي واستمتع بأسهل وأسرع تجربة تسوّق وتمويل.`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/shopping-third.png",
    },
    why_product: {
      title: "رحلتك للتسجيل اسهل واسرع",
      subtitle: "",
      description: "عشان تكون عميل كونتكت ناو , الخطوات سهلة و سريعة:",

      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/boy_shopping.webp",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",

          text: `حمل تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact" style="color: blue;">كونتكت ناو </a> .`,
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "أنشئ حسابك وكمّل عملية التسجيل.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "هيوصل لك قرار الحد الأقصى .",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "لو تم الموافقة، زور أقرب فرع كونتكت خلال 30 يوم لتوقيع العقد.",
        },
      ],
      note: "بعد التوقيع هتكون عميل كونتكت وجاهز للاستفادة من كل المميزات!",
    },
    faq: {
      title: "الاسئلة الشائعة ",
      items: [
        {
          q: "ايه مميزات تقسيط مشترياتك مع كونتكت ؟",
          a: `
          <p>تمويل التسوق من كونتكت بيخلّي تجربة الشراء بتاعتك أسهل وأنسب لميزانيتك.
و من مميزاته:
</p>
        <ul style="margin-top: 10px;">
           <li>تقدر تقدّم وتحصل على موافقة فورية على التمويل.</li>
  <li>بنوفّر تمويل لحد مليون جنيه لأي منتج أو خدمة محتاجها.</li>
  <li>عندك حرية اختيار خطة الدفع اللي تناسبك لحد 5 سنين.</li>
  <li>عملية التقسيط بسيطة وسريعة ومن غير مقدم.</li>
  <li>تقدر تشتري من شبكة كبيرة من التجّار في كل المجالات.</li>
  <li>من غير أي مصاريف خفية أو رسوم إضافية.</li>
  <li>خيارات دفع مرنة ومريحة.</li>
  <li>فريق خدمة عملاء محترف ومتعاون متواجد لخدمتك 24 ساعة يوميًا.</li>
        </ul>
      `,
        },
        {
          q: "إيه المستندات اللي محتاجها علشان أعمل تمويل التسوق من كونتكت؟",
          a: `
        <p>لو عندك حساب مفتوح مع كونتكت، كل اللي عليك إنك تجيب بطاقة الرقم القومي، وتستخدم رقم الموبايل المسجل في الخدمة لما تزور التاجر.
</p>
      `,
        },
        {
          q: `إزاي أستخدم خدمة "اشترِ الآن وادفع لاحقًا" من كونتكت؟ `,
          a: `
          <p>تقدر تشتري اللي محتاجه النهارده وتسدّد على أقساط مريحة بخطوات بسيطة جدًا:</p>
        <ol style="margin-top: 10px;">
        <li>اختار التاجر اللي هتشتري منه من شبكة التجّار اللي بنتعامل معاهم.</li>
  <li>روح الفرع ومعاك بطاقة الرقم القومي ورقم الموبايل المسجل بالخدمة.</li>
  <li>اختار خطة الدفع اللي تناسب ميزانيتك.</li>
  <li>هيوصلك كود تأكيد (OTP) في رسالة SMS، سلّمه للكاشير.</li>
  <li>بعدها هيوصلك فاتورة إلكترونية برسالة SMS بكل تفاصيل العملية.</li>
        </ol>
      `,
        },
        {
          q: "أقدر أشتري إيه بخطط تقسيط المشتريات من كونتكت؟",
          a: `
          <p>خدمة تمويل التسوق عندنا بتغطّي تقريبًا كل حاجة ممكن تحتاجها!
سواء عايز تشتري لابتوب، موبايل، تلفزيون، دهب، مستحضرات تجميل، أو أي منتج استهلاكي تاني. شبكة التجار الواسعة بتغطي كل الفئات والعلامات التجارية في مصر، علشان تلاقي اللي محتاجه بسهولة وبـ تسهيلات دفع تناسبك.
</p>
    `,
        },
        {
          q: "أعمل إيه لو عندي سؤال أو محتاج مساعدة بخصوص خطط الدفع؟",
          a: `
          <p>فريق خدمة العملاء متاح على مدار 24 ساعة علشان يقدملك الدعم اللي تحتاجه.
تقدر تكلمنا في أي وقت على الخط الساخن 16177 أو <a href="https://contact.eg/our-branches">تزور أقرب فرع ليك</a> علشان نساعدك شخصيًا.</p>
      `,
        },
      ],
    },
    section_a: {
      title1: "فترة سداد",
      title2: "36 شهر",
      body: `إشتري كل إحتياجاتك بدون عمليات معقدة فقط برقم البطاقة و برقم موبايلك, من خلال نظام كنتكت الإلكتروني للتس الشراء و التقسيط من أكثر من 1000 منفذ بيع في جميع محافاظات الجمهورية. نظام التقسيط من كونتكت تسوق هو أفضل و أسرع طريقة لتمويل جميع مشترياتك من خلال شبكة ضخمة من المنافذ التجارية و معارض التجزئة و المتاجر الكبري و توكيلات الماركات العالمية. والذي يتيح لك حرية تحديد مبلغ الدفعة المقدمة و يقدم أنظمة التقسيط بفترات سداد تتراوح من 6 أشهر إلي 36 شهر.`,
    },
    section_b: [
      "إختار التاجر من خلال شبكتنا",
      "توجه إلى المتجر مع بطاقة الرقم القومي والموبايل المسجل في الخدمة",
      "حدد مبلغ القسط وفترة السداد التي تتراوح ما بين 6 إلى 60 شهر",
      "هيوصلك رمز العملية من خلال رسالة نصية على موبايلك لتقديمها للتاجر",
      "هيوصلك فاتورة إلكترونية من خلال رسالة نصية على موبايلك",
    ],
  },
  manasik: {
    id: 57,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3d-airplane.png",
      color: "#547865",
      title: "جاهز تبدأ أهم رحلة في حياتك؟",
      description:
        "قدم أونلاين النهاردة أو زور أقرب فرع لكونتكت, وخلّينا نكون معاك في كل خطوة على الطريق. ",
    },
    price: "سعر الرحلة",
    section_2: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik_section_2.webp",
      description:
        "مع مناسك بنقدملك حلول تمويلية متوافقة مع الشريعة الإسلامية ومصممة خصيصاُ علشان تدعم كل اللي بيخططوا للسفر لإداء الحج والعمرة. برامجنا تتيح لك خطط سداد مرنة علشان تقدر تركز علي أداء الفريضة بأمان وراحة, سواء كنت بتجهز لأول رحلة أو بتخطط للزيارة مرة تانية.",
    },
    section_3: {
      title: "مميزات برنامج مناسك من كونتكت",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik_section_3.webp",
      list: [
        "متوافق مع أحكام الشريعة الإسلامية",
        "خطط سداد مرنة:سدد تكاليف الرحلة بالتقسيط علي دفعات مريحة.",
        "سرعة الموافقة:ابدأ التخطيط دلوقتي لأن الإجراءات بسيطة.",
        "دعم مستمر:فريقنا جاهز لدعمك في كل خطوة من رحلتك.",
      ],
    },
    section_4: {
      description:
        "دلوقتي مفيش حاجة تمنعك من تحقيق حلمك بزيارة بيت الله الحرام. مع كونتكت, الحج والعمرة أقرب وأسهل من أي وقت فات. ابدأ رحلتك النهاردة مع مناسك من كونتكت",
    },

    main_section: {
      titleLine1: "تمويل",
      titleLine2: "السفر والسياحة",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3d-airplane.png",
      header: "سافر براحتك مع تمويل السياحة والسفر من كونتكت",
      description: "",
      paragraph2: `لو بتحلم بأجازة هادية، مغامرة جديدة، أو رحلة عائلية ، كونتكت بتساعدك تحقق خطط سفرك بكل سهولة. حلول تقسيط السفر والسياحة من كونتكت بتديك مرونة تحجز رحلتك دلوقتي و تدفع علي اقساط تناسب ميزانيتك.من الرحلات المحلية لحد السفر برا مصر، اختار الوجهة والتجربة والباقي علينا.
      <p>وجهتك الجاية على بُعد خطوة! قدم أونلاين النهاردة أو زور أقرب<a style="color:white;text-decoration:none;" href="https://contact.eg/our-branches"> فرع لكونتكت</a></p>`,
      buttonText: "قدّم الآن",
      subtitle: "وجهتك الجاية على بُعد ضغطة واحدة",
    },

    product_program_1: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/internal-travel.webp",
      title: `رحلات عطلة
       نهاية الأسبوع والسفر القصير`,
      paragraph: `محتاج فاصل سريع؟ خطط لرحلة قصيرة للساحل الشمالي، العين السخنة، الأقصر، أسوان، أو أي مكان بتحبه. 
      استمتع بعطلة نهاية الأسبوع من غير ما تشيل هم المبلغ كامل مقدمًا. 
      مع خطط التقسيط المرنة، رحلتك الجاية أقرب ما تتخيل.`,
      list: [],
    },

    product_program_2: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/europe-travel.webp",
      title: "باقات السفر الدولي",
      paragraph: `اكتشف العالم مع باقات سفر مميزة لأوروبا، آسيا، الخليج، أو أي وجهة في قائمة أحلامك. 
      سواء سياحة، تسوق، أواستكشاف ثقافات جديدة، كونتكت بتسهل عليك تمويل رحلتك بكل راحة.`,
      list: [],
    },

    product_program_3: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/family-travel.webp",
      title: "رحلات عائلية",
      paragraph: `خَلّي كل رحلة فرصة لذكريات حلوة مع عيلتك، تجمع بين الراحة والاستمتاع.
       من منتجعات على البحر لجولات في المدن و ملاهي، قسط رحلتك واستمتع بوقتك مع عيلتك من غير ضغط.`,
      list: [],
    },

    product_program_4: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-section-manasik.png",
      title: `تمويل
الحج والعمرة`,
      paragraph: `ابدأ تجربة تستحق كل خطوة فيها.
بتحلم تكمل مناسك الحج أو العمرة؟
مع كونتكت، حلمك بقى أقرب وأسهل. لو محتاج تمويل للحج أو تقسيط رحلة عمرة، 
إحنا موجودين علشان نسهّل عليك كل التفاصيل.
ومش بس كده! بنوفر كمان باقات الحج والعمرة عشان تعيش رحلتك بكل راحة وطمأنينة.
سلامك الداخلي بين إيديك. <a href="#apply-form" style="color: inherit; text-decoration: underline;">قدّم أونلاين</a> مع كونتكت.`,
      list: [],
    },

    section_title_1: {
      title: "شريكك الموثوق لرحلة شهر عسل مثالية",
      description: `استمتع بفرحة السفر مع شريك حياتك في شهر عسل مميز ومتفصّل على حسب أحلامكم. سواء بتحلموا برحلة هادئة على البحر، أو جولة رومانسية في أوروبا، أو مغامرة في بلد جديدة، كونتكت هتساعدك تحققوا ده بسهولة.

من خلال حلول تمويل مخصصة للمتزوجين حديثًا، تقدروا تسافروا وتستكشفوا العالم سوا من غير ما تقلقوا من الميزانية. ركّزوا في صناعة أحلى الذكريات، وإحنا نهتم إن شهر العسل اللي بتحلموا بيه يبقي سهل تحقيقه مع كونتكت.
قدّم أونلاين النهارده، وسيب كونتكت تهتم برحلة شهر العسل بتاعتكم.
      `,
    },

    section_title_2: {
      title: "استعد للعمرة والحج مع تمويل السياحة والسفر من كونتكت",
      description: `في كونتكت، هدفنا نوفرلك شعور بالرضا في موسم الحج اللي جاي، من غير ما تشيل هم تكلفة الحج من مصر بالتقسيط.
وباعتبارنا من أبرز شركات تمويل الحج، بنقدملك باقات متنوعة للحج والعمرة متوافقة مع أحكام الشريعة الإسلامية، وكمان خطط عمرة بالقسط تناسب احتياجاتك وميزانيتك.

لو بتدور على نظام تقسيط لمصاريف الحج من مصر، أو تمويل مريح للعمرة، أو حتى رحلة سفر مع أحبابك، إحنا في كونتكت موفرينلك كل اللي تحتاجه بسهولة ومرونة وراحة بال.
ممكن تقدّم أونلاين دلوقتي أو تزور أقرب فرع لكونتكت.`,
    },

    why_product: {
      title: "مزايا تمويل السياحة والسفر من كونتكت:",
      description: "استعد لرحلة مميزة مع مزايا مصممة لاحتياجاتك في السفر",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/manasik-travel.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط سداد مرنة تناسب ميزانيتك",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/approval-icon.svg",
          text: "موافقات سريعة ومن غير تعقيد",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/support-icon.svg",
          text: "فريق دعم مخصص لخدمتك في كل خطوة",
        },
      ],
    },

    why_contact: {
      title: "ليه تختار كونتكت لقرض الحج؟",
      subtitle: "",
      description: `مع حلول التمويل المميزة من كونتكت، رحلتك هتكون أسهل ومن غير أي ضغوط.
استمتع بمزايا تمويل تركّز فيها على الرحلة، وإحنا نهتم بالباقي:`,
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "خطط سداد مرنة تصل إلى 5 سنوات للحج و12 شهرًا للعمرة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: "تمويل يصل إلى 3 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Analytics.svg",
          text: "مقدم يبدأ من 20%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Pocedures.svg",
          text: "إجراءات سهلة وسريعة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/transactions-icon.svg",
          text: "معاملات متوافقة مع أحكام الشريعة الإسلامية",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إيه أنواع الرحلات اللي تقدر تقسطها من خلال كونتكت؟",
          a: `
        <p>تقدر تقسط رحلات ويك إند، سفر دولي، رحلات عائلية، شهر عسل، وكمان الحج والعمرة.</p>
      `,
        },

        {
          q: " ايه الحد الأقصى للتمويل؟",
          a: `
        <p>يوصل التمويل لحد 3 مليون جنيه للحج، ولحد مليون جنيه لباقي رحلات السفر والسياحة.</p>
      `,
        },

        {
          q: " الحد الأدنى للمقدم كام؟",
          a: `
        <p>المقدم يبدأ من 20% من إجمالي تكلفة الرحلة.</p>
      `,
        },

        {
          q: "مدة السداد قد إيه؟",
          a: `
        <p>مدة السداد حتي:</p>

        <ul style="margin-top: 10px;">
          <li>لحد 5 سنين للحج</li>
          <li>لحد 12 شهر للعمرة</li>
          <li>لحد 3 سنين للرحلات السياحية</li>
        </ul>
      `,
        },

        {
          q: "هل متاح خطط تقسيط شهر العسل من كونتكت؟",
          a: `
        <p>أكيد. في حلول تمويل مخصوصة للعرسان بخطط و فترات سداد لحد 3 سنين</p>
      `,
        },

        {
          q: "إزاي أقدر أمول تكاليف الحج أو العمرة مع كونتكت؟",
          a: `
        <p>التقديم سهل، وتقدر تختار الطريقة اللي تناسبك!</p>

        <strong>الاختيار الأول: التقديم أونلاين</strong>
        <ul style="margin-top: 10px;">
          <li>ادخل على صفحة كونتكت للسياحة والسفر</li>
          <li>املأ النموذج: كل اللي محتاجه اسمك بالكامل، رقم الموبايل، والرقم القومي</li>
          <li>هنكلمك فوراً: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم</li>
          <li>الموافقة بتوصلك بسرعة: بنراجع طلبك ونرجعلك بالرد في أسرع وقت</li>
          <li>اختار خطة التقسيط المناسبة ليك</li>
          <li>
           تابع وسدّد الأقساط بسهولة:
            من خلال
            <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a>
            أو تطبيق
            <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a>
          </li>
        </ul>

        <strong>الاختيار الثاني: التقديم من الفرع</strong>
        <p style="margin-top: 10px;">
          زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
          <a href="https://contact.eg/en/our-branches">تقدر تعرف أقرب فرع ليك من هنا.</a>
        </p>

        <p>كونتكت معاك في كل خطوة من خطوات الرحلة، من نية السفر وحتى رجوعك بالسلامة!</p>
      `,
        },

        {
          q: "إيه هي شروط تمويل مناسك الحج والعمرة من كونتكت؟",
          a: `
        <p>شروط تمويل الحج والعمرة من كونتكت مصممة عشان تسهّل عليك الرحلة وتخليها في متناولك:</p>

        <strong>شروط التقديم</strong>
        <ul style="margin-top: 10px;">
          <li>الجنسية أو الإقامة المصرية: لازم تكون معاك بطاقة رقم قومي سارية</li>
          <li>السن: متاح للبالغين من سن 21 لـ 65 سنة</li>
        </ul>

        <strong>الشروط المالية</strong>
        <ul style="margin-top: 10px;">
          <li>المقدم: حد أدنى 20% من إجمالي تكلفة البرنامج</li>
          <li>قيمة التمويل: ممكن توصل لحد 3 مليون جنيه، وبتغطي تذاكر السفر، الإقامة، والتأشيرات</li>
        </ul>
      `,
        },

        {
          q: "هل في برنامج خاص لتمويل العمرة فقط من كونتكت؟",
          a: `
        <p>أكيد! برنامج تمويل العمرة من كونتكت مصمّم مخصوص عشان يسهّلك الرحلة، وبيقدّم:</p>
        <ul style="margin-top: 10px;">
          <li>تقسيط على فترات تصل لحد 12 شهر</li>
          <li>مقدم يبدأ من 20%</li>
          <li>تمويل لحد 3 مليون جنيه</li>
          <li>معاملات متوافقة مع أحكام الشريعة الإسلامية</li>
        </ul>
        <p>سواء كانت عمرة أو حج، كونتكت دايمًا معاك في كل خطوة من رحلتك.</p>
      `,
        },

        {
          q: "إيه هي المستندات المطلوبة للتقديم على تمويل السياحة والسفر من كونتكت؟",
          a: `
        <p>جمع مستندات تمويل الحج أو قرض العمرة سهل وبسيط! كل اللي هتحتاجه:</p>
        <ul style="margin-top: 10px;">
          <li><strong>بطاقتك الشخصية:</strong> بطاقة الرقم القومي أو جواز السفر</li>
          <li><strong>عرض سعر مختوم من شركة السياحة اللي هتسافر معاها</strong></li>
        </ul>
        <p>
          فريقنا ممكن يطلب منك بيانات إضافية حسب نوع البرنامج أو التفاصيل الخاصة بالسفر.
          لو عندك أي استفسار،
          <a href="https://contact.eg/en/contact-us">تواصل معانا</a>
          وإحنا هنوجهك في كل خطوة بكل وضوح!
        </p>
      `,
        },
      ],
    },
  },
  finishing: {
    id: 43,
    cover: {
      img: "/home-interior-main.png",
      color: "#95664B",
      title: "شطّب بيتك دلوقتي مع كونتكت",
      description: `جرب تمويل التشطيب دلوقتي، أو زور أقرب  فرع كونتكت وفريقنا هيكون جاهز يساعدك!`,
    },
    price: "مبلغ التشطيب",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "التصميم والتشطيب",
      mainImage: "/home-interior-main.png",
      header: "جدّد بيت أحلامك مع تمويل التشطيب من كونتكت ",
      description: "",
      paragraph2: `جدّد بيتك لمكان و مساحة تعكس ذوقك وشخصيتك. مع تمويل التشطيب وتمويل التصميم الداخلي من كونتكت، تقدر تجدّد كل المساحات، وتوظف أفضل خبراء الديكور والتصميم في مصر، وكمان تستفيد من حلول مرنة زي تقسيط تشطيب الشقة، تمويل الديكور، وتمويل تجديد البيت. كونتكت هتساعدك تلون بيتك بالشكل المريح ليك، وتخلي رحلة التجديد سهلة، ميسّرة، ومع لمسة ألوان مميزة.`,
      buttonText: "قدم الآن",
      subtitle: "جرب تمويل التشطيب دلوقتي",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior-second.png",
      title: "جدد بيتك مع تمويل التشطيب المرن",
      paragraph: `حوّل ستايل بيتك لحقيقة مع تمويل التشطيب من كونتكت. اختار شركة التصميم الداخلي اللي تحبها وإحنا هنوفّرلك التمويل اللازم للتجديد. استمتع بخطط تقسيط لحد  5 سنين، تمويل لحد 4 مليون جنيه، مقدم يبدا من 20% بس، وكل ده من خلال إجراءات سهلة وسريعة.
قدّم دلوقتي، افتح حسابك مع كونتكت ، واستعد تعيش في البيت اللي كنت دايمًا بتحلم بيه!
`,
      list: [],
    },
    third_section: {
      title: "تمويل سهل لتجديد بيتك مع كونتكت",
      subtitle: "",
      description: `مع كونتكت، بنسهّللك تمويل تجديد البيت، تقسيط تشطيب الشقة، وخيارات تمويل الديكور المرنة حسب احتياجاتك. مع خدمة الحاسب الآلي على موقعنا، تقدر تحسب اقساطك بسرعة، تقارن بين خطط التمويل المختلفة، وتختار اللي يناسب ميزانيتك. خد زمام الأمور في تجديد بيتك وانت مطمّن، لأن  كونتكت بتخلي العملية أسهل وأريح. جرب خدمة الحاسب الآلي  دلوقتي وحقق حلمك!`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-interior-third.png",
    },

    why_product: {
      title: "",
      subtitle: "",
      description: `استمتع بمزايا تمويل مرن وسهل يخليك تشطب بيتك على ذوقك `,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط تقسيط تصل إلى 5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 4 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "مقدم يبدأ من ٢٠ ٪",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "ايه مميزات تمويل التصميم والتشطيب مع كونتكت؟",
          a: `
          <p>كونتكت بتقدملك تمويل تشطيب أو تمويل تصميم داخلي يخليك تحول بيتك لحلم حقيقي بطريقة مريحة وسهلة.
المميزات اللي هتستفيد بيها:</p>
    <ul style="margin-top: 10px;">
      <li>خطط دفع مرنة للتصميم أو التشطيب لحد 5 سنين.</li>
      <li>تمويل لحد 6 مليون جنيه.</li>
      <li>مقدم بسيط يبدأ من 20% بس.</li>
      <li>إجراءات سريعة وسهلة علشان تبدأ مشروعك فورًا.</li>
      <li>حرية كاملة في اختيار شركة التصميم أو التشطيب اللي بتحبها.</li>
    </ul>
  `,
        },

        {
          q: "إزاي أقدّم على تمويل التصميم والتشطيب من كونتكت؟ ",
          a: `
          <p>التقديم بسيط جدًا، وتقدر تختار الطريقة اللي تناسبك:</p>
 <ul style="margin-top: 10px;">
    <li><strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 5px;">
        <li>ادخل على صفحة تمويل التصميم والتشطيب على موقعنا.</li>
        <li>املأ الاستمارة القصيرة: الاسم بالكامل، رقم الموبايل، ورقم البطاقة</li>
        <li>هيتواصل معاك ممثل من كونتكت لتأكيد البيانات وطلب أي مستندات إضافية لو محتاج.</li>
        <li>بنراجع الطلبات بسرعة علشان تبدأ في أقرب وقت.</li>
        <li>اختار خطة التقسيط اللي تناسبك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a></li>
      </ol>
    </li>
    <li style="margin-top: 10px;"><strong>الاختيار الثاني: التقديم من الفرع</strong>
     <p>زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.</p>
  </ul>      `,
        },
        {
          q: "ايه الخدمات اللي أقدر أموّلها من خلال تمويل التصميم والتشطيب؟",
          a: `
          <p>عندك حرية تموّل كل مراحل تشطيب أو تجديد بيتك، سواء ناوي تعمل تجديد شامل أو عايز تمويل ديكور.
إحنا بنوفّرك تمويل تصميم داخلي مرن يساعدك تحقق الرؤية بتاعتك وتخلّي كل ركن في بيتك على ذوقك.
</p>
      `,
        },
        {
          q: "لازم أتعامل مع شركة تصميم معينة لو هموّل تشطيباتي مع كونتكت؟ ",
          a: `
          <p>أبدًا! إحنا عارفين إن كل عميل له ذوقه الخاص ومساحته اللي بيحلم بيها.
تقدر تختار شركة التصميم أو التشطيب اللي تفضلها، واحنا هنتكفّل بـ تمويل التشطيب أو التجديد معاهم علشان تنفّذ مشروعك زي ما أنت عايز بالضبط.
</p>
            `,
        },
      ],
    },
    outro:
      "تمويل ديكورات وتشطيبات بيتك ده مشروع هدفنا فيه واحد وهو تحقيق أحلامك. أنت تختار شركة التصميم والتشطيب اللي تعجبك، وكونتكت هتموّل التكاليف. حلم تشطيب أو تجديد بيتك تقدر تحوله لحقيقة مع كونتكت. افتح حسابك مع كونتكت، واستعد للاستمتاع ببيتك الجديد باسلوب حياة مختلف.",
    section_a: {
      title: "4 مليون جنية",
      body: `برامج تمويل النقل تصل بحد أقصي إلي 2 مليون جنية مصري لسيارات النقل الجديدة, بفترات سداد تصل إلي 5 سنوات بمقدم يبدأ من 20% بأسهل الإجراءات كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية, فقط من خلال بطاقة الرقم القومي الخاصة بك تستطيع شراء منتجات التشطيب التي تحتاجها مثل الحوائط و الأرضيات, أبوب و شبابيك, دهانات  و ديكور, مستلزمات كهربائية, الأدوات الصحية و غيرها, من خلال شبكة سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري, كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترات تقيسط تتراوح من 6 إلي 60 شهراً.`,
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "بدون مقدم",
      body: `كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية من خلال شبكة  سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري. كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترة تفسيط تتراوح بين 6 إلي 60 شهرا حد ائتماني يصل إلي 750,000 جنية بدون مقدم أو مصاريف إضافية. لا يتطلب ملكية الوحدة أو الرهن العقاري أسرع و أسهل إجراءات للإصدار`,
    },
  },
  home_furniture: {
    id: 58,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-furniture.png",
      color: "#5E7EB5",
      title: "أنت على بعد خطوة من تجديد بيتك بالكامل!",
      description: `اكتشف خيارات تمويل فرش البيت دلوقتي، أو زور أقرب فرع كونتكت واستمتع بعملية سريعة، سهلة، ومريحة.`,
    },
    price: "مبلغ فرش البيت",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "فرش البيت",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-furniture.png",
      header: "جدد بيتك بأناقة مع تمويل فرش البيت من كونتكت ",
      description: "",
      paragraph2: `لو مستعد تجدد بيتك بقطع أثاث حديثة وفي نفس الوقت تحافظ على ميزانيتك، كونتكت بتقدملك الحل الأمثل ليك. مع خدمات تمويل فرش الشقة، تقسيط الأثاث المنزلي، تمويل الأثاث، تقسيط المفروشات، وتمويل فرش البيت، تقدر تطوّر شكل بيتك، تجدد مساحاتك، وتحقق أهدافك من غير أي ضغط مالي.`,
      buttonText: "قدم الآن",
      subtitle: "تحديث بيتك مستنيك!",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-second.png",
      title: "تقسيط الاثاث المنزلى بسهولة ومرونة",
      paragraph: `مع كونتكت، بنبذل كل جهودنا عشان نديك خطط دفع وتمويل فريدة متظبطة على احتياجاتك ورغباتك. لو كنت بتدور على تمويل أثاث بأسعار مريحة أو تمويل غرفة المعيشة، عندنا خطط تقسيط مرنة للأثاث تخليك تشتري قطعة الأثاث اللي بتحبها في مصر بسهولة.
ما تترددش في تجديد بيتك، اكتشف خطط الدفع عندنا، اختار اللي يناسبك وسيب الباقي علينا.
`,
      list: [],
    },
    third_section: {
      title: "ليه تختار كونتكت لتقسيط فرش البيت؟",
      subtitle: "",
      description: `مع كونتكت، تجهيز بيتك بقى أسهل وأريح من أي وقت فات. مع خطط تقسيط لحد 5 سنين، تقدر تتحكم في مصاريفك من غير أي ضغط مالي كبير. بنوفرلك تمويل لحد 3 مليون جنيه، يديك المرونة تختار الأثاث والتصميم اللي يناسب ذوق بيتك، حتى لو كنت بتعمل تجديد كامل للبيت أو مجرد قطعة مميزة.
المقدم بيبدأ من 20% بس. إجراءاتنا سريعة وواضحة علشان تجربتك تبقى سهلة من وقت التقديم لحد ما الاثاث يوصلك. 
مع الحلول المرنة والمريحة دي، هتقدر تجهّز بيتك بالشكل اللي بتحلم بيه بالظبط، من غير أي توتر، مع دعم كامل من كونتكت.
`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-home.png",
    },

    why_product: {
      title: "",
      subtitle: "",
      description: `استمتع بمزايا تمويل مرن وسهل و إفرش بيتك على ذوقك`,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "فترات سداد تصل إلى 5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 3 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "مقدم يبدأ من ٢٠ ٪",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "إمكانية دمج عروض سعر مختلفة في نفس الطلب",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إيه المميزات اللي باخدها لما أعمل تمويل فرش البيت مع كونتكت؟",
          a: `
    <p>سواء بتجهّز شقة جديدة أو بتجدّد فرش بيتك، كونتكت بتقدملك تمويل فرش الشقة وتقسيط الأثاث المنزلي بمزايا كتير:</p>
    <ul style="margin-top: 10px;">
      <li>خطط تقسيط مرنة للأثاث لحد 5 سنين.</li>
      <li>تمويل لحد 3 مليون جنيه لتغطية كل احتياجاتك من الأثاث.</li>
      <li>مقدم بسيط يبدأ من 20% بس.</li>
      <li>إجراءات سريعة وسهلة ومباشرة.</li>
      <li>تقدر تجمع عروض أسعار مختلفة من أكتر من محل وتقدمها في طلب تمويل واحد.</li>
    </ul>
  `,
        },

        {
          q: "إزاي أقدّم على تمويل فرش البيت من كونتكت؟ ",
          a: `
          <p>التقديم بسيط جدًا، وتقدر تختار الطريقة اللي تناسبك:</p>
 <ul style="margin-top: 10px;">
    <li><strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 5px;">
        <li>ادخل على صفحة تمويل فرش البيت على موقعنا.</li>
        <li>املأ الاستمارة القصيرة: الاسم بالكامل، رقم الموبايل، ورقم البطاقة</li>
        <li>هيتواصل معاك ممثل من كونتكت لتأكيد البيانات وطلب أي مستندات إضافية لو محتاج.</li>
        <li>بنراجع الطلبات بسرعة علشان تبدأ في أقرب وقت.</li>
        <li>اختار خطة التقسيط اللي تناسبك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a></li>
      </ol>
    </li>
    <li style="margin-top: 10px;"><strong>الاختيار الثاني: التقديم من الفرع</strong>
     <p>زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.</p>
  </ul>      `,
        },
        {
          q: "أعمل إيه لو عندي سؤال أو محتاج مساعدة بخصوص خطة الدفع أو الطلب؟",
          a: `
          <p>إحنا دايمًا في خدمتك! تقدر تكلمنا في أي وقت على الخط الساخن 16177، أو تبعتلنا رسالة على <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> ، أو تراسلنا على الإيميل: Info@contact.eg</p>
      `,
        },
        {
          q: "لازم أشتري من محل معين علشان أقدر أعمل تمويل من عندكم؟ ",
          a: `
          <p>أبدًا! أنت مش مرتبط بمحل واحد. تقدر تختار المحلات اللي تحبها وتجيب عروض أسعار من أكتر من مكان، وممكن كمان تخلّي كل العروض في طلب تمويل واحد علشان تفرش على ذوقك وبالطريقة اللي تناسبك.</p>
            `,
        },
      ],
    },
    outro:
      "لو عايز تشتري أثاث أو فرش لبيتك من أي مكان في مصر، كونتكت بتقدملك مجموعة متنوعة من خدمات وبرامج التمويل اللي تقدر تساعدك تحقق كل اللي تتمناه. مع خدمة تمويل الأثاث المنزلي من كونتكت، هتقدر تجدد بيتك بأسلوب جديد بسهولة وراحة من غير ما تقلق على الميزانية.",
  },
  factoring: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/factoring-cover.webp",
      color: "#BF6340",
      title1: "التخصيم",
      title2: "سيولة بسهولة",
      description: `عايز توفر فلوس وسيولة لاحتياجاتك واحتياجات مشروعك؟ اتـعـرّف على خدمة التخصيم من كونتكت، الحل اللي بيـسـمـحلك تستبدل فواتير مبيعاتك وتاخد فلوسها فـوراً بدون انتظار.التخصيم طريقة سهلة ومريحة توفرلك فلوس تـشـغـل بيها مشروعك من غير ما تاخد قرض ولا تقلل من ملكيتك. تقدر تستعمل الفلوس دي تدفع لمورديك، وتصرف على مـرتـبـات الموظفين، تدفع ضرايب، أو تستثمر في مشاريع جديدة. `,
    },
    outro:
      'كونتكت هي شركة رائدة في مجال "التخصيم" بمصر، بخبره طويلة في دعم الشركات من كل المجالات. سواء كنت مشروع صغير أو متوسط، شركة كبيرة، أو شركة متعددة الجنسيات، كونتكت تقدر تقدم حلول مميزة ومرنة تناسب احتياجاتك وأهدافك. لو عايز تعرف أكتر عن إزاي كونتكت تقدر تساعدك تكبر مشروعك من خلال "التخصيـــم"، اتصل بينا دلوقتي.',
  },
  clubs: {
    id: 44,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubMain.png",
      color: "#282781",
      title: "جاهز تستمتع في النادي؟",
      description: `قدّم أونلاين النهاردة أو زور أقرب فرع لكونتكت.`,
    },
    price: "قيمة التمويل",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "اشتراكات الأندية",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubMain.png",
      header: " انضم للنادي مع تمويل اشتراكات النوادي من كونتكت",
      description: "",
      paragraph2: ` لو بتدور على نادي رياضي، اجتماعي، كونتكت بتسهّلك الانضمام للمجتمع اللي بتحلم تكون جزء منه.
من خلال تمويل اشتراكات النوادي وخيارات قرض عضوية النادي بمرونة تامة، هتقدر توفّر لنفسك ولعيلتك أسلوب حياة أفضل.
`,
      buttonText: "قـَدم الآن",
      subtitle: " تقرّبك من حياة اجتماعية راقية",
    },
    why_contact: {
      title: "ليه تختار كونتكت لتمويل اشتراك النادي؟",
      subtitle: "",
      description:
        "لو عايز تعيش مستوى مختلف من الراحة والرفاهية،كونتكت بتقدملك تمويل مرن وسهل يخليك تدخل النادي اللي بتحلم بيه:",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: "خطط تقسيط لحد 5 سنين",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: " تمويل يوصل لـ 1.5 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: " من غير مقدم، إجراءات سريعة وسهلة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/SimpleHassleIcon.svg",
          text: " تفعيل فوري للاشتراك",
        },
      ],
    },
    why_product: {
      title: "مزايا قرض النوادي الرياضية من كونتكت",
      subtitle: "",
      description: "احصل على حلول تمويل مصممة لتناسب نمط حياتك وطموحاتك:",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyContactClub.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast.svg",
          text: " إجراءات سريعة وبسيطة",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",

          text: "خطط سداد مرنة ومريحة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feesClubIcon.svg",

          text: "تمويل اشتراكات النوادي الرياضية في مختلف أنحاء مصر",
        },
      ],
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportClub.png",
      title: "عضويتك في النادي اللي نفسك فيه مع كونتكت أسهل ",
      paragraph: `استمع بتجربة فريدة من نوعها مع كونتكت، الشركة الرائدة في حلول التمويل في مصر.
دلوقتي تقدر تقوم بتقسيط اشتراك النادي الرياضي أو الاجتماعي بسهولة وبأقساط مريحة.
انضم للنادي اللي دايمًا بتحلم بيه، واستمتع انت وعيلتك بمجتمع يليق بيكم.
`,
    },
    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إزاي أقدّم على تمويل اشتراكات الأندية من كونتكت؟",
          a: `
          <p>      التقديم بسيط، وتقدر تختار الطريقة اللي تناسبك!</p>
      <strong>الاختيار الأول: التقديم أونلاين</strong>
      <ul style="margin-top: 10px;">
        <li>ادخل على صفحة تمويل اشتراكات الأندية على موقع كونتكت.</li>
        <li>املأ النموذج المختصر: هنحتاج اسمك الكامل، رقم الموبايل، ورقم بطاقتك.</li>
        <li>تواصل شخصي: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم.</li>
        <li>موافقة سريعة: بنراجع الطلبات بسرعة علشان تبدأ في أقرب وقت.</li>
        <li>اختار خطة السداد المناسبة ليك.</li>
        <li>تابع وسدّد أقساطك بكل سهولة من خلال <a href="https://wa.me/20216177">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a> وانت في بيتك.</li>
      </ul>
      <strong>الاختيار التاني: التقديم من الفرع</strong>
      <p style="margin-top: 10px;">
       زور أقرب فرع ليك، وفريقنا هيقدملك المساعدة خطوة بخطوة
اعرف أقرب فرع  <a href="https://contact.eg/our-branches"> من هنا</a>
      </p>
      `,
        },
        {
          q: "تمويل اشتراكات الأندية من كونتكت بيشمل عضوية أي نوع من الأندية؟",
          a: `
          تقدر تموّل عضويتك في النوادي الرياضية، الاجتماعية، في مختلف أنحاء مصر.
سواء كنت بتشجّع موهبة رياضية عند أولادك أو عايز تستمتع بحياة أكثر نشاط، تمويل اشتراكات الأندية من كونتكت بيقدملك خطط سداد مرنة ومن غير مقدم!
      `,
        },
        {
          q: "إيه مميزات تقسيط اشتراكات الأندية مع كونتكت؟",
          a: `
          <p>      سواء كنت بتموّل عضوية نادي رياضي أو اجتماعي، إحنا هنا علشان نسهّل عليك الانضمام للنادي اللي بتحلم بيه.
      خطط التمويل من كونتكت بتوفر لك:
</p>
      <ul style="margin-top: 10px;">
        <li>تمويل لحد 1.5 مليون جنيه</li>
        <li>من غير أي مقدم</li>
        <li>فترات سداد مرنة توصل لحد 5 سنين</li>
        <li>إجراءات تقديم بسيطة وسريعة، سواء أونلاين أو من خلال الفرع</li>
        <li>تفعيل فوري للعضوية بعد الموافقة، علشان تبدأ تستمتع بناديك علطول!</li>
      </ul>
      `,
        },
        {
          q: "هل محتاج أدفع أي مقدم علشان أقدر أشترك في نادي من خلال تمويل كونتكت؟",
          a: `
      بدون مقدم!
      <br/>
      مع تمويل اشتراكات الأندية من كونتكت، بتدفع أقساط شهرية مريحة على مدار فترة ممكن توصل لـ 5 سنين، وبقيمة تمويل لحد 1.5 مليون جنيه، ومن غير أي مقدم على الإطلاق!
      `,
        },
      ],
    },

    outro:
      "تمويل اشتراك النادي مع كونتكت استثمار في مستقبلك وسعادة عيلتك. ماتفوتش الفرصة! قدم دلوقتي واحصل على الموافقة في دقايق. اتصل بينا النهاردة وخلينا نساعدك تحقق أحلامك.",
    clubs_title: "الاندية المشتركة",
    clubs: [
      [
        "نادي وادي دجلة",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club1.png",
      ],
      [
        "نادي ماتركس",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club2.png",
      ],
      [
        "نادي الزهور",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club3.png",
      ],
      [
        "نادي جزيرة الورد الرياضي",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club4.png",
      ],
      [
        "نادي الحوار",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club5.png",
      ],
      [
        "نادي بلاتينم قطامية",
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/club6.png",
      ],
    ],
  },
  maintainance: {
    id: 59,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance.png",
      color: "#DB8539",
      title: "تمويل الصيانة بقى أسهل",
      description: `اكتشف دلوقتى خيارات تمويل الصيانة عندنا أو زور أقرب فرع كونتكت وابدأ على طول!`,
    },
    price: "مبلغ الصيانة",
    main_section: {
      titleLine1: "تمويل ",
      titleLine2: "الصيانة",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance.png",
      header: "خلي الصيانة أسهل مع كونتكت",
      description: "",
      paragraph2: `تصليح عربيتك، أو صيانة بيتك، أو أي حاجة في ممتلكاتك ساعات بيبقى غالي ومرهق. مع كونتكت الموضوع بقى سهل! عندنا خطط تقسيط مريحة لصيانة كل اللي يهمك، لو محتاج تمويل صيانة البيت أو تمويل الإصلاح أو حتى تقسيط الصيانة للعربيات. هتقدر تجيب أحسن الخبراء في مصر وتدفع بعدين بسهولة وراحة بال.`,
      buttonText: "قدم الآن",
      subtitle: "اكتشف دلوقتى خيارات تمويل الصيانة عندنا",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance-second.png",
      title: "احسب اقساطك",
      paragraph: `مع كونتكت، تمويلك بقى سهل، واضح، ومظبوط على قد احتياجاتك. مع خدمة الحاسب الآلي على موقعنا، تقدر تحسب اقساطك بسهولة وتشوف كل خيارات التمويل المتاحة على راحتك. اختار الخطة اللي تناسبك، نظم دفعاتك بثقة، واستمتع براحة البال وانت متطمن إن كونتكت دايمًا معاك. جرب خدمة الحاسب الآلي دلوقتي وخد أول خطوة لتمويل من غير صعوبة!
`,
      list: [],
    },
    why_product: {
      title: "ليه تختار كونتكت لتمويل الصيانة؟",
      description:
        "مشاريع الصيانة ساعات بتكون مكلفة وبتاخد وقت كتير، لكن كونتكت بتخلي الموضوع سهل ومريح. حلول التمويل عندنا مصممة علشان تديك المرونة، الدعم، والسرعة اللي محتاجها علشان تحل أي مشاكل من غير أي تعب.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintenance-third.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط دفع مرنة لحد 24 شهر",
          desc: "استمتع بخطط دفع طويلة ومريحة متظبطة على ميزانيتك.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل لحد 1.5 مليون جنيه",
          desc: "خليك مطمّن إنك هتلاقي الدعم لأي مشروع صيانة، كبير أو صغير.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "مقدم يبدأ من 20% بس",
          desc: "خيارات ميسّرة تساعدك تبدأ على طول.",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast.svg",
          text: "إجراءات سريعة وسهلة",
          desc: " موافقات سريعة و خطوات بسيطة تخلي الصيانة مستمرة من غير توقف.",
        },
      ],
    },
    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "يه مميزات تمويل الصيانة من كونتكت؟",
          a: `
          <p>إحنا ف كونتكت بتسهّل عليك كل اللي يخص تمويل الصيانة، سواء لعربية، بيت، أو مشروع تجديد.
من المميزات اللي هتستفيد بيها:
</p>
        <ul style="margin-top: 10px;">
          <li>خطط دفع مريحة للصيانة لحد 24 شهر.</li>
          <li>تمويل لحد 1.5 مليون جنيه لتغطية أي أعمال صيانة كبيرة أو تجديدات.</li>
          <li>مقدم بسيط يبدأ من 20%</li>
          <li>إجراءات سهلة وسريعة من غير تعقيد.</li>
        </ul>
      `,
        },
        {
          q: "إزاي أقدّم على تمويل الصيانة من كونتكت؟ ",
          a: `
          <p>التقديم بسيط جدًا، وتقدر تختار الطريقة اللي تناسبك:</p>
 <ul style="margin-top: 10px;">
    <li><strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 5px;">
        <li>ادخل على صفحة تمويل الصيانة على موقعنا.</li>
        <li>املأ الاستمارة القصيرة: الاسم بالكامل، رقم الموبايل، ورقم البطاقة</li>
        <li>هيتواصل معاك ممثل من كونتكت لتأكيد البيانات وطلب أي مستندات إضافية لو محتاج.</li>
        <li>بنراجع الطلبات بسرعة علشان تبدأ في أقرب وقت.</li>
        <li>اختار خطة التقسيط اللي تناسبك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a></li>
      </ol>
    </li>
    <li style="margin-top: 10px;"><strong>الاختيار الثاني: التقديم من الفرع</strong>
     <p>زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.</p>
  </ul>      `,
        },
        {
          q: "ينفع أختار مركز الخدمة أو الفني اللي أنا عايزه؟ ",
          a: `
        <p>أكيد! تقدر تختار الفني أو مركز الخدمة اللي انت واثق فيهم سواء في تمويل صيانة العربية أو تمويل صيانة البيت، وإحنا هنوفّرك خطة دفع مرنة تغطي التكلفة بالكامل.</p>
      `,
        },
        {
          q: "أقدر أموّل إيه من خلال تمويل الصيانة من كونتكت؟  ",
          a: `
          <p>معانا تقدر تموّل أي نوع من مشاريع الصيانة أو الإصلاح، زي:</p>
        <ul style="margin-top: 10px;">
        <li>تمويل صيانة العربيات علشان ترجع بحالة ممتازة.</li>
        <li>تمويل صيانة البيت لو ناوي تجدّد أو تطوّر بيتك.</li>
        <li>تمويل تحسين العقارات علشان تحافظ على شكل وأداء الممتلكات بتاعتك.</li>
        </ul>
      `,
        },
        {
          q: "إيه المستندات المطلوبة لتقديم طلب تمويل الصيانة؟ ",
          a: `
          <p>كل اللي محتاجه في البداية هو بطاقة رقم قومي سارية. وبحسب مبلغ التمويل وحالتك، ممكن نطلب مستند بسيط إضافي زي إثبات دخل أو سكن علشان نكمّل طلب تمويل الصيانة بسهولة وسرعة.</p>
      `,
        },
      ],
    },
    outro:
      "لو بتدور على طريقة مضمونة ومريحة تموّل بيها الصيانة بتاعتك، اختار كونتكت. افتح حسابك النهاردة مع كونتكت واستمتع بمزايا وبرامج حصرية.",
  },
  trucks: {
    id: 32,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/truck-cover.png",
      title: "عربيتك النقل مستنياك!",
      description:
        "استكشف خطط تمويل النقل عندنا, أو زور أقرب فرع  وسيب الباقي على فريقنا!",
    },
    price: "سعر السيارة",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "النقل",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/truck-cover.png",
      header: "اكتشف الخطط المرنة لتمويل النقل مع كونتكت",
      description: "",
      paragraph2: `تمويل النقل بقى أسهل وأسرع مع كونتكت!
حلول تمويل عربيات النقل متصممة علشان تدعم كل الشركات مهما كان حجمها.
سواء عايز توسّع شغلك أو تحدّث سيارتك، هتلاقي إجراءات سريعة وبسيطة وخطط تمويل مرنة تناسب احتياجاتك، بما في ذلك خطط سداد النقل الثقيلة.

كونتكت بتوفر تمويل لكل أنواع النقل الثقيل: الصغيرة، المتوسطة، والثقيلة، وكمان المقطورات النصفية، السطحات، السطحات متعددة الارتفاع، وغيرها.
وكمان بنوفر خيارات تمويل لسيارات النقل الجديدة، المستعملة، والمستوردة.

اكتشف حلول تمويل النقل عندنا، أو زور أقرب فرع وسيب الباقي على فريقنا!`,
      buttonText: "قدّم الآن",
      subtitle: "اكتشف حلول تمويل النقل من كونتكت",
    },

    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-truck.png",
      title: "ليه تختار كونتكت لتمويل النقل",
      paragraph: ` في كونتكت دايمًا هدفنا نعدي توقعات عملائنا! حلول تمويل النقل وخطط السداد المرنة متصممة عشان تكون على راحتك. مع خطط سداد لغاية 5 سنين وتمويل يوصل لـ8 مليون جنيه، وكمان مقدم يبدأ من 20% بس، هتحصل على إجراءات سريعة وبسيطة ترضيك تمامًا.
زور موقعنا أو أقرب  فرع ليك، وفريقنا هيكون جاهز يساعدك في أي وقت.`,
      list: [],
    },

    plans_steps: {
      title: `اكتشف
خطط تقسيط النقل`,
      steps: [
        {
          name: "النقل الجديد – النظام العادي",
          role: [
            "مقدم من 30%",
            "سداد لغاية 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونصف",
          ],
        },
        {
          name: "النقل الجديد – النظام المرن",
          role: [
            "مقدم من 20%",
            "سداد لغاية 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونصف",
          ],
        },
        {
          name: "النقل الاستيراد – النظام العادي",
          role: [
            "مقدم من 30%",
            "سداد لغاية 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونصف",
          ],
        },
        {
          name: "النقل الاستيراد – النظام الاقتصادي",
          role: [
            "مقدم من 50%",
            "سداد لغاية 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونصف",
          ],
        },
        {
          name: "النقل الاستيراد – النظام الاقتصادي بلس",
          role: [
            "مقدم من 50%",
            "سداد لغاية 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونصف",
          ],
        },
        {
          name: "النقل الاستيراد – النظام المرن",
          role: [
            "مقدم من 20%",
            "سداد لغاية 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونصف",
          ],
        },
        {
          name: "النقل المستعمل – النظام الاقتصادي",
          role: [
            "مقدم من 50%",
            "سداد لغاية 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونصف",
          ],
        },
        {
          name: "النقل المستعمل – النظام الاقتصادي بلس",
          role: [
            "مقدم من 50%",
            "سداد لغاية 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونصف",
          ],
        },
      ],
    },

    business_plans_steps: {
      title: `استفيد بمرونة تقسيط
النقل لشركتك مع كونتكت`,
      steps: [
        {
          name: "النقل الجديد – النظام العادي",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونص",
          ],
        },
        {
          name: "النقل الجديد – النظام المرن",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونص",
          ],
        },
        {
          name: "النقل الاستيراد – النظام العادي",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونص",
          ],
        },
        {
          name: "النقل الاستيراد – النظام الاقتصادي",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونص",
          ],
        },
        {
          name: "النقل الاستيراد – النظام الاقتصادي بلس",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونص",
          ],
        },
        {
          name: "النقل الاستيراد – النظام المرن",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونص",
          ],
        },
        {
          name: "النقل المستعمل – النظام الاقتصادي",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 4 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهر ونص",
          ],
        },
        {
          name: "النقل المستعمل – النظام الاقتصادي بلس",
          role: [
            "مقدم من 30%",
            "تقسيط لحد 5 سنين",
            "إمكانية السداد المبكر",
            "التأمين اختياري",
            "أول قسط بعد شهرين ونص",
          ],
        },
      ],
    },
    why_product: {
      title: "",
      subtitle: "",
      description: `استمتع بمزايا تمويل مرن وسهل يخليك تشتري كل انواع سيارات النقل الثقيل اللي نفسك فيها`,
      imageSrc: "",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "فترات سداد تصل إلى 5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 8 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "مقدم يبدأ من ٢٠ ٪",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/id-card-icon.svg",
          text: "كل أنواع سيارات النقل الثقيل، من الصغيرة للكبيرة، ومن النص نقل للمقطورة",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إيه نوع عربيات النقل اللي أقدر أمول ثمنها مع كونتكت؟",
          a: `
        <p>
          تقدر تموّل تقريبًا أي نوع من سيارات النقل مع كونتكت،
          سواء كانت صغيرة، متوسطة، أو نقل تقيل.
          كمان بنوفّر تمويل الجديدة، المستعملة، أو حتى المستوردة،
          علشان نديك الحل اللي يناسب احتياجات شغلك.
        </p>
      `,
        },

        {
          q: "ليه اختار تمويل عربية النقل بتاعتي مع كونتكت",
          a: `
          <p>لأن كونتكت بتوفّرك راحة ومرونة في كل خطوة، وده من خلال:</p>
        <ul style="margin-top: 10px;">
          <li>خطط تقسيط مرنة لعربيات النقل لحد 5 سنين.</li>
          <li>تمويل يوصل لحد 8 مليون جنيه يدعم المشاريع الصغيرة والكبيرة.</li>
          <li>مقدم يبدأ من 20% علشان تحافظ على سيولة شركتك.</li>
          <li>إجراءات بسيطة وسريعة علشان تبدأ شغلك في أسرع وقت.</li>
          <li>من غير تأمين إجباري، مع إمكانية السداد الكامل أو الجزئي في أي وقت.</li>
        </ul>
        <p>
          سواء بتحدّث أسطولك أو بتشتري أول شاحنة ليك،
          حلول تمويل المركبات من كونتكت مصممة علشان تخلي العملية أسهل وأوفر.
        </p>
      `,
        },

        {
          q: "إزاي أقدّم على تمويل سيارات النقل مع كونتكت؟",
          a: `
        <p>التقديم بسيط جدًا، وتقدر تختار الطريقة اللي تناسبك!</p>

        <strong>الاختيار الأول: أونلاين</strong>
        <ul style="margin-top: 10px;">
          <li>ادخل على صفحة تمويل سيارات النقل على موقع كونتكت</li>
          <li>
            املأ الاستمارة القصيرة:
            الاسم الكامل، رقم الموبايل، ورقم البطاقة
          </li>
          <li>
            مكالمة للتأكيد:
            ممثل من كونتكت هيكلمك يراجع البيانات ويطلب أي مستندات إضافية لو محتاج
          </li>
          <li>
           موافقة سريعة:
            هنراجع طلبك ونبعتلك الموافقة المبدئية في أقرب وقت
          </li>
          <li>اختار خطة التقسيط اللي تناسبك</li>
          <li>
            تابع وسدّد الأقساط بسهولة:
            من خلال
            <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a>
            أو تطبيق
            <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a>
          </li>
        </ul>

        <strong>الاختيار التاني: في الفرع</strong>
        <p style="margin-top: 10px;">
          زور أقرب فرع ليك، وفريقنا هيساعدك خطوة بخطوة في تقديم الطلب.
          <a href="https://contact.eg/en/our-branches">اعرف أقرب فرع ليك.</a>
        </p>
      `,
        },

        {
          q: "إيه المستندات المطلوبة لتقديم طلب تمويل النقل من كونتكت؟",
          a: `
        <p>
          في البداية، كل اللي هنحتاجه منك هو الاسم الكامل، رقم الموبايل،
          ورقم البطاقة.
          بعد كده فريقنا هيبلغك بالمستندات المطلوبة حسب نوع تمويل
           سيارة النقل التجارية اللي بتقدّم عليها.
        </p>
      `,
        },

        {
          q: "ينفع أموّل عربية نقل مستعملة أو مستوردة مع كونتكت؟",
          a: `
        <p>
          أكيد!
          كونتكت بتوفّر تمويل سيارات النقل التجارية سواء كانت مستعملة أو مستوردة،
          وبأنظمة مختلفة تناسب ميزانيتك.
          تقدر تختار بين خطط اقتصادية أو مرنة،
          وتحدد قيمة المقدم ومدّة السداد اللي تناسبك.
        </p>
      `,
        },

        {
          q: "إزاي بتشتغل أنظمة التقسيط لأصحاب الأنشطة التجارية والمهن الحرة؟",
          a: `
        <p>
          لو عندك سجل تجاري وبطاقة ضريبية،
          تقدر تستفيد من أنظمة تقسيط مخصصة لأصحاب الأنشطة والمشاريع.
          الأنظمة دي مثالية لشركات المقاولات، التصنيع و النقل.
        </p>

        <ul style="margin-top: 10px;">
          <li>مقدم يبدأ من 30%.</li>
          <li>فترات سداد لحد 5 سنين حسب نوع العربية.</li>
          <li>مرونة في السداد الكامل أو الجزئي.</li>
          <li>من غير تأمين إجباري.</li>
        </ul>
      `,
        },
      ],
    },

    outro:
      "لو شغال في مجال البناء أو التصنيع أوالشحن والخدمات اللوجستية في مصر، وبتنقل بضائع تقيلة، كونتكت بتقدملك تمويل لكل معداتك وشاحناتك، كلمنا دلوقتي عشان نساعدك من خلال خطط تمويل مختلفة لكل أنواع العربيات النقل الجديدة والمستعملة والمستوردة، بإجراءات سهلة ومرنة.",
    plans_title: "خطط التقسيط",
    plans: [
      {
        name: "النقل الجديد – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الجديد – النظام المرن",
        role: [
          "مقدم يبدأ من 20%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام المرن",
        role: [
          "مقدم يبدأ من 20%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
    ],
    business_plans_title:
      "خطط التقسيط لأصحاب المهن و الأنشطة التجارية (سجل تجاري و بطاقة ضريبية)",

    business_plans: [
      {
        name: "النقل الجديد – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الجديد – النظام المرن",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام المرن",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
    ],
  },
  cars: {
    id: 37,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/auto-main.png",
      color: "#282780",
      title: "تمويل السيارات",
      description: `قدّم أونلاين النهاردة أو زور أقرب فرع لكونتكت!`,
    },
    price: "سعر السيارة",

    main_section: {
      titleLine1: "تمويل",
      titleLine2: "السيارات",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/auto-main.png",
      header: "",
      description: "",
      paragraph2: `لو عايز تقسط سيارة جديدة، أو مستعملة، كهرباء أو بنزين, كونتكت بتوفرلك تمويل مرن يناسب احتياجاتك.
      استمتع بإجراءات بسيطة وخطط تقسيط مصممة مخصوص ليك، وكل ده من مكان واحد مع 25 سنة خبرة في مجال تمويل السيارات في مصر.`,

      buttonText: "قدم اونلاين النهاردة",
      subtitle: "امتلك السيارة اللي بتحلم بيها بكل سهولة وثقة",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-auto.png",
      title: "احصل على تمويل سيارتك الجديدة النهاردة!",
      paragraph: ` بتفكر تشتري  سيارة  جديدة أو بتدور على تمويل سيارة مستعملة، كهربا أو بنزين؟
 حلول تمويل السيارات من كونتكت مصممة علشان توفرلك أقصى درجات المرونة.
مع أنظمة تقسيط سيارات مستعملة و تمويل سيارات جديدة بأقل مقدم، تقدر تمتلك السيارة اللي بتحلم بيها أيًّا كان نوعها أو موديلها.
 وكمان تقدر تحسب قسطك بكل سهولة من خلال <a href="#apply-form" style="color: inherit; text-decoration: underline;">حاسبة قرض السيارة</a> الخاص بكونتكت علشان تختار الأنسب لميزانيتك.
وبفضل انتشارنا الواسع في أكبر معارض السيارات على مستوى الجمهورية، كونتكت هي شريكك الموثوق في تمويل السيارات الجديدة والمستعملة بسبب خبرتنا 25 سنة في مجال تمويل السيارات في مصر.
`,
      list: [],
    },
    third_section: {
      title: "خد موافقة سيارتك فورًا مع كونتكت!",
      subtitle: "",
      description: `مع كونتكت، الموضوع أسهل وأسرع مما تتخيل! هتقدر تاخد موافقة فورية على العربية في دقايق معدودة.
 كل الإجراءات بسيطة ومريحة من غيرانتظارعلشان وقتك عندنا غالي.
سواء بتشتري أول عربية ليك أو ناوي تغيّر لعربية جديدة, كونتكت هتسهّلك الطريق عالآخر وتخليك تطلع بالعربية اللي نفسك فيها في أسرع وقت.
لأن معانا، وقتك يهمنا قبل أي حاجة.`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-auto.png",
    },
    why_product: {
      title: "امتلك سيارة أحلامك مع أنظمة تقسيط السيارات من كونتكت",
      subtitle: " ",
      description: `استمتع بمزايا تمويل مرن وسهل يخليك تسوق السيارة اللي نفسك فيها بكل راحة:`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/why-auto.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط سداد تصل حتى 5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 15 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "مقدم يبدأ من 10% فقط",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "إمكانية إضافة التأمين حسب رغبتك",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/id-card-icon.svg",
          text: "توفر خدمة دعم إجراءات ترخيص للسيارة ( المتابعة في المرور , إنهاء إجراءات التجديد نيابة عن العميل) بدون أي تكاليف إضافية",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/expertise-icon.svg",
          text: "خدمات إضافية زي: التسجيل، التأمين، وتجديد الرخصة",
        },
      ],
    },
    why_contact: {
      title: "ليه تختار كونتكت لتقسيط سيارتك؟",
      subtitle: ``,
      description: `سهولة، سرعة، وخبرة، عشان كده كونتكت هي شريكك المضمون في تمويل العربيات في مصر`,
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/process-icon.svg",
          text: "إجراءات مبسّطة وسريعة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/team-icon.svg",
          text: " فريق متخصص لمساعدتك خطوة بخطوة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/car-icon.svg",
          text: "25 سنة خبرة في مجال تمويل السيارات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast-icon.svg",
          text: "عملية تمويل سهلة من أول تقديم لحد استلام السيارة",
        },
      ],
    },

    plans_steps: {
      title: "خطط التقسيط",
      steps: [
        {
          name: "السيارات الكهربائية",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين اختياري",
            "فترات سداد تصل الي 5 سنوات",
            "إمكانية السداد المبكر الكلي أو الجزئي",
          ],
        },
        {
          name: "نيو بلس",
          role: [
            "مقدم يبدأ من 20%",
            "التأمين إجباري",
            "فترات سداد تصل إلى 5 سنوات",
            "أول قسط بعد 3 أشهر",
          ],
        },
        {
          name: "الإقتصادي",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين إجباري",
            "فترات سداد تصل الي 3 سنوات",
          ],
        },
        {
          name: "الإقتصادي بلس",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين إجباري",
            "فترات سداد تصل الي 5 سنوات",
            "إمكانية السداد المبكر بعد سنة من التعاقد",
          ],
        },
        {
          name: "المرن",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين إجباري",
            "فترات سداد من 3 إلى 5 سنوات",
            "إمكانية السداد المبكر بعد سنة من التعاقد",
            "إمكانية تأجيل جزء من المقدم",
          ],
        },
        {
          name: "المرن بلس",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين اختياري",
            "فترات سداد تصل الي 5 سنوات",
            "إمكانية السداد المبكر الكلي أو الجزئي",
            "إمكانية تأجيل جزء من المقدم",
          ],
        },
        {
          name: "السيارات المستعملة",
          role: [
            "مقدم يبدأ من 20 ٪",
            "التأمين اختياري",
            "فترات سداد تصل الي 5 سنوات",
          ],
        },
        {
          name: "الشركات",
          role: [
            "مقدم يبدأ من 10%",
            "التأمين إجباري",
            "فترات سداد من 2 إلى 5 سنوات",
            "إمكانية السداد المبكر بعد سنة من التعاقد",
          ],
        },

        {
          name: "40% جديد",
          role: [
            "مقدم يبدأ من 40 ٪",
            "معدل فائدة تنافسي",
            "التأمين اختياري",
            "فترات سداد تصل إلى 5 سنوات",
            "إمكانية السداد المبكر بعد سنة من التعاقد",
          ],
        },

        {
          name: "40% مستعمل",
          role: [
            "مقدم يبدأ من 40٪",
            "معدل فائدة تنافسي",
            "تقسيط سيارات مستعملة لموديلات حتى 10 سنوات",
            "تقسيط سيارات مستعملة بعداد يصل إلى 150,000 كم",
            "فترات سداد تصل إلى 5 سنوات",
          ],
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إيه هي شروط تمويل السيارات من كونتكت؟",
          a: `
      <ul style="margin-top: 10px;">
        <li>السن يكون بين 21 و 65 سنة</li>
        <li>ومعاك بطاقة رقم قومي سارية</li>
      </ul>
      <p>إحنا بنسهّلها عليك عشان تبدأ مشوارك من غير تعقيدات!</p>
    `,
        },
        {
          q: "إزاي أقدّم على تمويل سيارة من كونتكت؟",
          a: `
          <p>التقديم سهل، وتقدر تختار الطريقة اللي تناسبك!</p>
      <strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 10px;">
        <li>ادخل على صفحة تمويل السيارات من كونتكت.</li>
        <li>املأ النموذج: كل اللي محتاجه اسمك بالكامل، رقم الموبايل، والرقم القومي.</li>
        <li>هنكلمك فوراً: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم.</li>
        <li>الموافقة بتوصلك بسرعة: بنراجع طلبك ونرجعلك بالرد في أسرع وقت.</li>
        <li>اختار خطة التقسيط المناسبة ليك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">الواتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a>.</li>
      </ol>
      <strong>الاختيار الثاني: التقديم من الفرع</strong>
      <p style="margin-top: 10px;">
       زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.
      </p>
    `,
        },
        {
          q: "هل ممكن أمول سيارة من كونتكت ببطاقة الرقم القومي بس؟",
          a: `
          <p> أيوة! مع كونتكت تقدر تبدأ طلبك وتاخد موافقة فورية في دقائق قليلة باستخدام بطاقتك الشخصية فقط.
فريق الدعم جاهز لمساعدتك في أي وقت على16177.
</p>
     
    `,
        },
        {
          q: "هل أقدر أمول سيارة مستعملة مع كونتكت؟",
          a: `
          <p>أكيد! خطة تمويل كونتكت المخصصة للسيارات المستعملة بتوفر لك:</p>
      <ul style="margin-top: 10px;">
      <li>تقسيط مرن لحد 5 سنين</li>
      <li>تمويل يوصل لـ 15 مليون جنيه</li>
      <li>مقدم يبدأ من 10% فقط (ومن غير تأمين إجباري!)</li>
      <li>ونفس سرعة الموافقة اللي بتحصل عليها مع تمويل السيارات الجديدة!</li>
      </ul>
    `,
        },
        {
          q: "إيه ماركات السيارات المستعملة اللي أقدر أمولها من كونتكت؟",
          a: "إحنا بنمول مجموعة كبيرة من السيارات المستعملة، مع شروط معينة علشان نضمن الجودة: تقدر تمول سيارات مستعملة من الماركات دي: مرسيدس، بي إم دبليو، سكودا، أودي، فولكس فاجن، جيب، ميني كوبر، تويوتا، ميتسوبيشي، كيا، هيونداي، نيسان، أوبل، سيات، شيفروليه، وفيات. عشان تكون السيارة مؤهلة،تقدر تقسط موديلات لحد ١٠ سنين فاتت وبحد أقصي ١٥٠،٠٠٠ كيلو للعداد",
        },
        {
          q: "إيه شروط تمويل السيارات الصيني المستعملة مع كونتكت؟ ",
          a: `خلّينا تمويل السيارات الصيني المستعملة أوفر مع مقدم أقل!
نسبة المقدم المطلوبة بقت 30%  وكل شروط تمويل السيارات المستعملة هتفضل زي ما هي، مع خطط تقسيط مرنة لغاية 5 سنين ومبالغ تمويل توصل لـ15 مليون جنيه, بنفس إجراءات الموافقة السهلة والسريعة.
`,
        },
        {
          q: "هل كونتكت بتساعد في إجراءات رخصة السيارة؟",
          a: "أكيد وبنكون معاك خطوة بخطوة، عشان نوفر وقتك ومجهودك، فريقنا هيقدر يخلص لك إجراءات إصدار وتجديد رخصة سيارتك وكل المتابعات المطلوبة مع إدارات المرور، يهمنا إنك تركز في فرحة العربية الجديدة",
        },
      ],
    },
    models: {
      title: "اكتشف موديلات العربيات المستعملة مع كونتكت",
      subtitle: `بنوفرلك "تقسيط" مجموعة كبيرة ومميزة من العربيات المستعملة اللي تناسب احتياجاتك وميزانيتك.
       دلوقتي تقدر تقسط عربيات مستعملة لموديلات لحد 10 سنين او بعداد يوصل لحد 150,000 كم. 
ماركات المستعمل إللي بينطبق عليها موديلات ١٠ سنين فاتت او ١٥٠،٠٠٠ كم:
`,
      list: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/seat.png",
          label: "سيات",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mercedes.png",
          label: "مرسيدس",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bmw.png",
          label: "بي إم دبليو",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/skoda.png",
          label: "سكودا",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/audi.png",
          label: "أودي",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/volkswagen.png",
          label: "فولكس فاجن",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/jeep.png",
          label: "جيب",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/min-cooper.png",
          label: "ميني كوبر",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/toyota.png",
          label: "تويوتا",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mitsubishi.png",
          label: "ميتسوبيشي",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/kia.png",
          label: "كيا",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hyundai.png",
          label: "هيونداي",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/nissan.png",
          label: "نيسان",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/opel.png",
          label: "أوبل",
        },
      ],
      outro:
        "اختار عربيتك مع كونتكت دلوقتي، وقدّم على تمويل العربيات المستعملة النهارده!",
    },
    outro:
      "عايز تمتلك عربية أحلامك بسهولة؟ حلول تمويل السيارات عندنا صممت عشان تساعدك. إحنا عارفين إن شراء عربية ممكن يكون استثمار كبير، عشان كده بنقدملك حلول دفع وتمويل مرنة تتناسب مع ميزانيتك. سواء كنت عايز عربية جديدة أو مستعملة، عندنا الحل التمويلي المناسب ليك.",
    plans_title: "خطط التقسيط",
    plans: [
      {
        name: "السيارات الكهربائية",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر الكلي أو الجزئي",
        ],
      },
      {
        name: "نيو بلس",
        role: [
          "مقدم يبدأ من 20%",
          "التأمين إجباري",
          "فترات سداد تصل إلى 5 سنوات",
          "أول قسط بعد 3 أشهر",
        ],
      },
      {
        name: "الإقتصادي",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد تصل الي 3 سنوات",
        ],
      },
      {
        name: "الإقتصادي بلس",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
        ],
      },
      {
        name: "المرن",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد من 3 إلى 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
          "إمكانية تأجيل جزء من المقدم",
        ],
      },
      {
        name: "المرن بلس",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر الكلي أو الجزئي",
          "إمكانية تأجيل جزء من المقدم",
        ],
      },
      {
        name: "السيارات المستعملة",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
        ],
      },
      {
        name: "الشركات",
        role: [
          "مقدم يبدأ من 10%",
          "التأمين إجباري",
          "فترات سداد من 2 إلى 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
        ],
      },
    ],
  },
  education: {
    id: 50,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/EducationMain.png",
      color: "#282781",
      title:
        "احجز تذكرتك للمستقبل، وخلّي كونتكت تكون شريكك من النهارده عشان تحققه",
      description: `  قدّم دلوقتي وابدأ أول خطوة تجاه حلمك! ممكن تقدم  اونلاين أو تزور أقرب فرع لكونتكت.`,
    },
    price: "قيمة التمويل",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "التعليم",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/EducationMain.png",
      header: "عايز توصل لقمة النجاح التعليمي وتحقق أهدافك؟",
      description: "",
      paragraph2:
        "مع أنظمة تقسيط التعليم من كونتكت، هنوفرلك الدعم المالي اللي تحتاجه في كل مرحلة من رحلتك التعليمية, من المدرسة و الجامعة، للدراسات العليا, و الدكتوراه أو الدبلومات.",

      buttonText: "قدم اونلاين مع كونتكت",
      subtitle: "كل اللي عليك تركّز عليه هو هدفك وخلي كونتكت دايمًا شريك نجاحك",
    },

    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportingEdu.png",
      title: "معاك في كل مراحل التعليم",
      list: [
        {
          q: "رحلة تعليمية متكاملة تبدأ من هنا : تقسيط مصاريف المدارس بكل سهولة",
          a: "بتخطط لمستقبل ولادك، و نفسك توفر لهم أحسن تعليم. مع  إحنا هنا علشان نسهّل عليك المهمة. من خلال أنظمة تقسيط مرنة ومصممة لتناسب ميزانيتك، تقدر تضمن مستقبل ابنك أو بنتك من غير ضغط مادي. استثمر في تعليمهم النهاردة وخلي الباقي علي كونتكت.",
        },
        {
          q: "ابدأ مشوارك الأكاديمي بثقة وتمويل الجامعة علينا.",
          a: "لو أنت طالب بتحلم تدخل أفضل الجامعات الخاصة وتدرس برامج أكاديمية على مستوى عالمي، كونتكت معاك في كل خطوة. بنوفرلك خطط تقسيط مصاريف الجامعات الخاصة، علشان تركز على مستقبلك من غير أي ضغط مالي. ركز على النجاح وخلي كونتكت تهتم بالباقي.",
        },
        {
          q: "حقق طموحاتك في مستقبلك المهني مع تمويل الدراسات العليا من كونتكت",
          a: "بتخطط تبدأ الماجستير أو الدكتوراه؟ مع تمويل الماجستير والدكتوراه، الطريق بقي أسهل. بنقدملك حلول تمويل مرنة، لو كنت حابب تطور من مستواك الأكاديمي أو تاخد خطوة جديدة في مشوارك المهني، إحنا معاك في كل خطوة. ابدأ النهاردة، وخلي كونتكت شريكك في بناء مستقبلك.",
        },
      ],
    },
    why_product: {
      title: "ليه تختار كونتكت لتقسيط مصاريف التعليم؟",
      subtitle: "",
      description: `في كونتكت، إحنا مش بس بنسهّل العبء المالي, إحنا بنصنع مستقبل أفضل
رسالتنا هي تمكين الجيل الجديد من تحقيق أحلامهم التعليمية من خلال حلول تمويل ذكية وسهلة الوصول، تفتح لهم أبواب الفرص بدون عوائق.
`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyContactEdu.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: " الوصول إلى تعليم عالي الجودة بدون تنازلات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hassleEduIcon.svg",
          text: "  عملية موافقة سريعة وسهلة بدون تعقيدات",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",

          text: " حماية لمدخراتك واستقرار مالي لعيلتك",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط سداد مرنة تصل إلى 12 شهرًا (للمدارس، الجامعات, الدورات التدريبية)",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",

          text: "بدون مقدم",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",

          text: "تمويل يصل إلى 2 مليون جنيه",
        },
      ],
    },
    faq: {
      title: "أسئلة شائعة عن تقسيط مصاريف التعليم",
      items: [
        {
          q: "إيه هي شروط تقسيط المصاريف الدراسية من كونتكت؟",
          a: ` <p> الحصول على تمويل تعليمي من كونتكت بسيط ومباشر! كل اللي عليك:</p>
      <ul style="margin-top: 10px;">
        <li>تكون مواطن مصري، ومعاك بطاقة رقم قومي سارية.</li>
        <li>تقدم فاتورة رسمية بالمصروفات الدراسية من الجهة التعليمية.</li>
      </ul>
      <p>وده كل المطلوب ، من غير أي مقدم!</p>
    `,
        },
        {
          q: "إزاي أقدم على تمويل مصاريف التعليم من كونتكت؟",
          a: `
          <p>التقديم سهل، وتقدر تختار الطريقة اللي تناسبك!</p>
      <strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 10px;">
        <li>ادخل على صفحة تمويل التعليم من كونتكت.</li>
        <li>املأ النموذج: كل اللي محتاجه اسمك بالكامل، رقم الموبايل، والرقم القومي.</li>
        <li>هنكلمك فوراً: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم.</li>
        <li>الموافقة بتوصلك بسرعة: بنراجع طلبك ونرجعلك بالرد في أسرع وقت.</li>
        <li>اختار خطة التقسيط المناسبة ليك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال واتساب أو تطبيق كونتكت ناو.</li>
      </ol>
      <strong>الاختيار الثاني: التقديم من الفرع</strong>
      <p style="margin-top: 10px;">
       زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.
      </p>
    `,
        },
        {
          q: "ممكن أقسط مصاريف المدارس الخاصة من خلال كونتكت؟",
          a: `
          <p>      أكيد! تمويل التعليم من كونتكت بيغطي كل المراحل من الحضانة لغاية الثانوية، وبيشمل:</p>
      <ul>
        <li>جميع المدارس الخاصة والإنترناشيونال في مصر.</li>
        <li>تمويل مصاريف دراسية لحد 2 مليون جنيه.</li>
        <li>تقسيط المصروفات على فترة تصل إلى 12 شهر.</li>
      </ul>
      <p> من غير أي مقدم وبموافقة سريعة!</p>
    `,
        },
        {
          q: "إيه الورق المطلوب لتقسيط المصاريف الدراسية؟",
          a: `
          <p>  تجهيز أوراق تمويل التعليم سهل وبسيط! كل اللي هتحتاجه:</p>
      <ul style="margin-top: 10px;">
        <li><strong>إثبات الجنسية المصرية:</strong> بطاقة الرقم القومي أو جواز السفر.</li>
        <li><strong>فاتورة المصروفات الرسمية:</strong> صادرة من الجهة التعليمية اللي هتدرس فيها.</li>
        <li><strong>إثبات الدخل:</strong> مفردات مرتب للموظفين وكشف حساب بنكي لأصحاب الأعمال الحرة.</li>
      </ul>
      <p>فريقنا ممكن يطلب منك معلومات إضافية حسب نوع التمويل اللي بتقدّم له. <a href="https://contact.eg/contact-us">تقدر تتواصل معانا في أي وقت،</a>  وإحنا هنساعدك خطوة بخطوة في كل المتطلبات والإجراءات!</p>
    `,
        },
        {
          q: "هل التمويل بيشمل برامج الماجستير والدكتوراه؟",
          a: `
          <p> أكيد! مع كونتكت، تقدر بكل سهولة تموّل دراسات الماجستير أو الدكتوراه. بنوفر لك خطط سداد مرنة توصل لـ 3 سنين للماجستير، و5 سنين للدكتوراه.</p>
    `,
        },
        {
          q: "ممكن أمول دورات تدريبية أو دبلومات مهنية؟",
          a: `
          <p> طبعًا! حلول التمويل اللي بنقدّمها مصممة لدعم جميع أنواع التعليم (حتى البرامج التعليمية قصيرة المدة) عشان تقدر تطوّر مهاراتك في أي مرحلة من مشوارك.</p>
    `,
        },
      ],
    },

    outro:
      "من غير ما تقلق على المصاريف أو الظروف تـمـنعـك تـكـمـل حلمك فى الوصول لأعلى الشهادات وتضمن أفضل مستوى تعليم لأولادك ، قدم على تمويل التعليم من كونتكت ومتعطلش مستقبلك.",
  },
  mortage: {
    id: 39,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage.png",
      title: "جاهز تبدأ الخطوة الكبيرة تجاه بيت أحلامك؟",
      description: "قدّم أونلاين النهاردة أو زور أقرب فرع لكونتكت",
    },
    price: "سعر الوحدة",
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "مميزات نظام تمويل بيتك",
      body: [
        "مقدم 25% من قيمة الوحدة",
        "تمويل يصل إلى 6 مليون جنيه",
        "فترات سداد تصل إلى 10 سنوات",
        "شاملة جميع الوحدات السكنية بجميع أنواعها سواء كانت (داخل كومباوند أو خارجه بشكل منفرد)",
      ],
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: `أو احصل على تمويل بضمان بيتك يصل إلى 50% من قيمته من خلال نظام "إعادة تمويل بيتك"`,
      body: [
        "بدون مقدم",
        " تمويل نقدي يصل إلى 6 مليون جنيه",
        "فترات سداد تصل إلى 5 سنوات",
        " التمويل يشمل جميع الوحدات السكنية بجميع أنواعها سواء كانت (داخل كومباوند أو خارجه بشكل منفرد)",
      ],
    },
    card_section_title: "البرامج",
    cards: [
      {
        name: "اقتصادي",
        role: [
          "بدون مقدم",
          "تمويل يصل إلى 6 مليون جنية",
          "فترات سداد تصل الي 5 سنوات",
        ],
      },
      {
        name: "المرن",
        role: [
          "بدون مقدم",
          "تمويل يصل إلى 6 مليون جنية",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد الكلي أو الجزئي بعد سنه",
        ],
      },
    ],
    home_equity: {
      title: "إعادة تمويل بيتك",
      description:
        'لو محتاج سيولة وبتدور على طريقة مريحة ومضمونة؟ جرب "إعادة تمويل بيتك" من كونتكت عشان تحصل على تمويل لغاية 75% من قيمة بيتك الحالية، واستغـل الفلوس في انك تجدد بيتك، تسـدِّد ديونك، تـصـرف على تعليم أولادك، أو حتى تستثمرها.',
      outro: {
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
        content:
          'لو عايز توفر فلوس وتحقق اللي تتمناه من غير ما تبيع بيتك، "إعادة تمويل بيتك" من كونتكت هو الحل المناسب ليك. اتصل بينا النهاردة واستفسر أكتر.        ',
      },
    },
    home_finance: {
      title: "تمويل المنزل",
      description:
        "تمويل بيتك وسيلة تحقق بيها أحلامك. بنساعدك تعيش في المكان اللي تحبه، بكل وسائل الراحة اللي انت عايزها، وانت مطمن إنك عملت استثمار ذكي لمستقبلك.      ",
      outro: {
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortgage-section.webp",
        content: `الفرصة مش بتتكرر كتير، كونتكت بتقدملك أسهل وأسرع تمويل. اتصل بينا النهاردة واعرف إزاي تقدر تموّل شقة أحلامك مع "تمويل عقاري" من كونتكت.          `,
      },
    },

    main_section: {
      titleLine1: "التمويل",
      titleLine2: "العقاري",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage.png",
      header: "اسكن في بيتك الجديد مع حلول التمويل العقاري من كونتكت",
      description: "",
      paragraph2:
        " حقّق حلمك بامتلاك بيتك الجديد مع تمويل عقاري مرن وفعال من كونتكت، يشمل كل ما تحتاجه من قرض عقاري، شراء شقة بالتقسيط، أو حتى رهن عقاري, وكل ده في مكان واحد وبإجراءات سهلة. لو كنت بتشتري أول شقة ليك، بتستثمر في عقار، أو بتدور على أفضل عروض التمويل العقاري في مصر، كونتكت بتقدملك الحلول اللي تناسب احتياجاتك وظروفك.",
      buttonText: "قدّم أونلاين النهاردة",
      subtitle: "أبدأ أول خطوة تجاه بيتك الجديد بثقة وسهولة.",
    },

    product_program_1: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/second-section-mortage.png",
      title: "التمويل العقاري في مصر",
      paragraph: `جاهز تبدأ الخطوة الصح؟
      لو بتدور على شقة أو فيلا أحلامك ، كونتكت للتمويل العقاري موجود علشان يسهّل عليك المشوار في مصر.
بنقدّم لك حلول مرنة مصممة على قد احتياجاتك، سواء كنت محتاج تمويل شقة، قرض لشراء فيلا، أو حابب تحسب التزاماتك بدقة باستخدام حاسبة التمويل العقاري الخاصة بينا.
مع كونتكت، تقدر تشتري العقار اللي يناسبك بالشكل اللي يريحك، وبإجراءات سريعة وبسيطة. <a href="#apply-form" style="color: inherit; text-decoration: underline;">قدّم أونلاين</a> النهاردة أو زور أقرب <a href="/our-branches" style="color: inherit; text-decoration: underline;">فرع لكونتكت</a>, وإحنا هنكمل معاك باقي الطريق.
`,
      list: [],
    },

    section_title: {
      title: "تمويل الفيلا أسهل مع كونتكت",
      description: `
      حلمك بامتلاك فيلا تناسب أسلوب حياتك وميزانيتك بقى قريب جدًا!
 مع كونتكت، الانتقال لبيتك المثالي بقى أبسط وأسهل من أي وقت.
إحنا معاك خطوة بخطوة علشان نخلي التجربة سهلة ومن غير أي تعقيدات، ونوفّرلك ولعيلتك المساحة والراحة وجودة الحياة اللي تستحقوها.

      `,
    },

    product_program_2: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fourth-section-mortage.png",
      title: " إعادة تمويل بيتك مع كونتكت",
      paragraph: `بتدورعلى طريقة مرنة وسهلة للحصول على تمويل لاحتياجاتك الشخصية أو مشروعك؟
 مع برنامج "إعادة تمويل بيتك" من كونتكت، تقدر تحصل على تمويل يصل إلى 75% من قيمة بيتك الحالية، من غير ما تبيع.
لو كنت بتخطط لتجديد بيتك، سداد ديون، تمويل تعليم، أو استثمار جديد, إحنا معاك في كل خطوة.
<p style="color: inherit; font-weight: 700; margin:0;margin-top: 15px;font-size: 20px;">مزايا البرنامج:</p>
  <ul style="margin-top: -30px; padding-right:1.5rem">
    <li style="margin-top: -5px;"> خطط سداد تصل إلى 7 سنوات</li>
    <li style="margin-top: -10px;">تمويل يصل إلى 15 مليون جنيه</li>
    <li style="margin-top: -10px;"> من غير مقدم</li>
    <li style="margin-top: -10px;"> متاح لجميع الوحدات السكنية داخل أو خارج الكمبوندات في جميع أنحاء مصر</li>
  </ul>
 <p style="color: inherit; margin-top:-20px"> <a href="#apply-form" style="color: inherit; text-decoration: underline;"> قدم أونلاين </a>أو زور أقرب <a href="/our-branches" style="color: inherit; text-decoration: underline;"> فرع لكونتكت</a></p>`,
      list: [],
    },

    why_product: {
      title: " اختار مكان يناسب نجاحك مع تمويل الوحدات التجارية من كونتكت",
      description:
        "في كونتكت، هنساعدك تفتح أبواب لفرص جديدة لشغلك من خلال حلول تمويل عقاري تجاري مصممة على حسب احتياجك. سواء كنت بتشتري عيادة، محل تجاري أو مكتب لمشروعك أو عشان تستثمر فيها وتأجرها، كونتكت بتقدملك حلول تمويل مرنة بتتناسب مع طبيعة شغلك، وتساعدك تشترى المكان اللي يناسب أحلامك.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mortage-restaurant.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: "مقدم 25% من قيمة الوحدة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 15 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "فترات سداد تصل إلى 10 سنوات",
        },

        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/HomeIcon.svg",
          text: "تمويل الوحدات التجارية بجميع أنواعها (عيادات، محلات، مكاتب)",
        },
      ],
    },

    why_contact: {
      title: "ليه تختار كونتكت لتمويل بيتك؟",
      subtitle: `مع كونتكت للتمويل العقاري، هتحقق هدفك بأسلوب ذكي ومريح.
 قدّم النهاردة وابدأ أول خطوة تجاه بيت أحلامك.
`,
      description:
        "حقق حلمك بامتلاك منزل إلى واقع بخطط تمويل مصممة على قد احتياجاتك:",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Financing1.svg",
          text: " تمويل الشقق والفيلات ",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: "تمويل يصل إلى 15 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: " خطط سداد لحد 10 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Analytics.svg",
          text: " مقدم يبدأ من 25% فقط",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Pocedures.svg",
          text: "إجراءات بسيطة وسريعة",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إزاي أقدّم على تمويل عقاري من كونتكت؟ ",
          a: `
      <p>التقديم سهل، وتقدر تختار الطريقة اللي تريحك:</p>
    <strong>الاختيار الأول: التقديم أونلاين</strong>
    <ul style="margin-top: 10px;">
      <li>ادخل على صفحة التمويل العقاري من كونتكت</li>
      <li>املأ النموذج المختصر: اسمك بالكامل، رقم الموبايل، ورقم بطاقتك</li>
      <li>مكالمة شخصية: فريق كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي مستندات إضافية لو لزم</li>
      <li>موافقة سريعة:  بنراجع الطلبات بسرعة علشان تبدأ في أسرع وقت</li>
      <li>اختار خطة السداد اللي تناسبك</li>
      <li>
  تابع وسدّد أقساطك بكل سهولة من خلال
  <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a>
  أو تطبيق
  <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a>،
  وانت في بيتك
</li>

      
    </ul>
    <strong>الاختيار التاني: التقديم من الفرع</strong>
   <p style="margin-top: 10px;">زور أقرب فرع ليك، وفريقنا هيساعدك خطوة بخطوة
اعرف أقرب فرع من <a href="https://contact.eg/en/our-branches">هنا </a></p>`,
        },

        {
          q: "ممكن أمول أي نوع من العقارات مع كونتكت؟",
          a: `<p>
  تقدر تموّل مجموعة كبيرة من الوحدات السكنية، زي
  <strong>الشقق، الفيلات،</strong>
  أو أي وحدة سكنية
  <strong>داخل أو خارج الكمباوند.</strong>
  كونتكت بتسهّل عليك كل خطوة بتمويل مرن وسلس.
</p>
`,
        },

        {
          q: `إيه هو برنامج "إعادة تمويل بيتك" من كونتكت؟`,
          a: `<p>
  برنامج
  <strong>«إعادة تمويل بيتك»</strong>
  بيسمح لك تستفيد من قيمة العقار اللي بتمتلكه، وتاخد تمويل يوصل لـ
  <strong>75%</strong>
  من قيمته الحالية في السوق
  <strong>(من غير ما تدفع مقدم)</strong>.
  حل ذكي ومرن لو محتاج تمويل إضافي من عقارك في مصر.
</p>
`,
        },

        {
          q: "ليه أختار كونتكت للتمويل العقاري في مصر؟",
          a: `<p>
  إحنا بنسهّل عليك تملّك بيت في مصر بطريقة
  <strong>مرنة وبسيطة</strong>.
  مميزاتنا:
</p>

<ul style="margin-top: 10px; padding-left: 18px; line-height: 1.6;">
  <li>تمويل لحد <strong>10 مليون جنيه</strong></li>
  <li>خطط سداد توصل لـ <strong>10 سنين</strong></li>
  <li>مقدم يبدأ من <strong>25%</strong> بس</li>
  <li><strong>إجراءات سريعة</strong> وأوراق <strong>بسيطة</strong></li>
  <li>
    متاح لكل أنواع الوحدات:
    <strong>شقق، فيلات، وغيرها</strong>
  </li>
</ul>

<p>
  طريقة مباشرة وآمنة تحقق بيها حلمك
  <strong>بامتلاك البيت اللي نفسك فيه</strong>.
</p>
`,
        },
      ],
    },
  },
  leasing: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/leasing-cover.webp",
      color: "#4AA2A6",
      title1: "تأجير تمويلي",
      title2: "طوّر قدراتك ونجح أعمالك",
      description: `كونتكت هي شركة رائدة في تقديم خدمات التأجير التمويلي لمختلف القطاعات في مصر. لو عايز تجهز منشآة طبية، مركز أشعه أو تحاليل أو تطور أسطول النقل الخاص بشركتك، كونتكت هتساعدك في تنمية أعمالك بأسهل الحلول وأفضل الخدمات التمويلية اللي بتضمنلك السرعة والنجاح للوصول لأهدافك.`,
    },
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "مزايا كونتكت تأجير تمويلي",
      body: [
        "دفعة مقدمة تبدأ من 10% طبقاً لنوع الأصل",
        "فترات سداد تصل إلى 5 سنوات",
        "شبكة واسعة من الموردين المعتمدين لأفضل المصنعين والماركات العالمية",
        "خطط سداد متنوعة مصممة لتناسب احتياجاتك",
        "إجراءات واضحة بدون تعقيدات",
        "التمويل يشمل تجهيزات العيادات والمنشآت الطبية وسيارات الإسعاف بأحدث أجهزة الرعاية الصحية",
        "التمويل يشمل وسائل النقل من السيارات الشخصية إلى السيارات التجارية (نقل خفيف، متوسط وثقيل) بالإضافة إلى الحافلات والڤان.",
      ],
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "كيف نعمل",
      description: `لتبسيط الإجراءات صممنا الحلول لترتكز علي القيمة السوقية للأصول التي تحتاجها الشركة. كما أن خبراتنا الطويلة ساعدتنا علي تقديم خدمات شاملة 
  و متخصصة بشكل أفضل و بأعلي إستفادة لك و لأنشتطتك التجارية.`,
      list: [
        [
          "إختار الأصول المناسبة لنشاطك",
          "من خلال شبكة الموردين والشركاء تغطى قطاعات الأدوات الطبية والنقل سواء كانت جديدة أو مستعملة لنضمن وصولك لأفضل المعدات التي تحتاجها لتنمية وتطوير نشاطك",
          "1",
        ],
        [
          "استكمال إجراءات التقديم",
          "فقد فمنا بتبسيط الإجراءات بشكل يسمح لك بمعرفة جميع الخطوات و المستندات المطلوبة بكل وضوح وشفافية. وكذلك الرد علي جميع استفساراتك بسرعة وفى المواعيد المحددة.",
          "2",
        ],
        [
          "اختيار خطة الدفع التي تناسب احتياجاتك",
          "اختيار خطة الدفع التي تناسبك مع مراعاة القيمة السوقية للأصل الذى تختاره مع وضوح وشفافية جميع المصاريف بداية من الدفعة الأولى والرسوم الإدارية المطلوبة منك ، وبدون أي رسوم أخرى غير معلنة",
          "3",
        ],
      ],
    },
    outro:
      "كونتكت هي شريك موثوق فيه بيفهم أهداف مشروعك ويساعدك تحققها. اتصل بينا النهاردة وخلينا نساعدك تطور قـدرة مشروعك.",
  },
  green_finance: {
    id: 36,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/greenMain.png",
      color: "#92B338",
      title: "جاهز تاخد الخطوة الجاية؟",
      description: "ممكن تقدم اونلاين أو تزور أقرب فرع لكونتكت.",
    },
    price_desc: " الواح الطاقة الشمسية – الصوب الزراعية – منتجات زراعية اخري ",
    price: "السعـــر",
    main_section: {
      titleLine1: "حلول",
      titleLine2: "التمويل الأخضر",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/greenMain.png",
      header: "استثمر في  حلول التمويل الأخضر، واحصد مستقبل مستدام!",
      description: "",
      paragraph2: `مع حلول التمويل الأخضر من كونتكت، دلوقتي تقدر تموّل مشروعاتك الزراعية أو مشروعات الطاقة المتجددة بطريقة ذكية ومستدامة.
 سواء كنت بتستثمر في الطاقة النظيفة أو بتطوّر في مجالك الزراعي، إحنا جنبك علشان تكبر بمسؤولية وتحقق أرباحك بثبات.`,
      buttonText: "قدّم اونلاين مع كونتكت.",
      subtitle: "فكر بذّكاء",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportingGreen.png",
      title: "برامج التمويل الأخضر المتاحة فى كونتكت",

      list: [
        {
          q: "أنظمة الطاقة الشمسية",
          a: "حابب تعيش حياة صحية أكتر؟ مع حلول تقسيط الطاقة الشمسية للمنازل والشركات من كونتكت، دلوقتي تقدر تركب نظام طاقة شمسية وتوفر في مصاريف الكهرباء من غير ما تدفع كل التكلفة مرة واحدة. تمويل مرن، طاقة نظيفة، ومستقبل أخضر يبدأ من بيتك أو شركتك. ابدأ رحلتك مع كونتكت النهارده! ممكن تقدم أونلاين أو تزور أقرب فرع لكونتكت.",
        },
        {
          q: "تمويل الري الحديث: استثمر بذكاء، واحصد أكثر",
          a: "مع كونتكت، طوّر مزرعتك بأنظمة ري ذكية وموفّرة للمياه بدون عبء مالي في البداية. بنقدملك حلول تمويل مرنة لأنظمة الري الحديثة تساعدك على: زيادة الإنتاج، تقليل استهلاك المياه، وتخفيض التكاليف التشغيلية. مع كونتكت، حياة صحية لمستقبل أفضل! ممكن تقدم أونلاين أو تزور أقرب فرع لكونتكت.",
        },
        {
          q: "التمويل الأخضر للصوب الزراعية ومعدات الثروة السمكية: استثمر بذكاء لمستقبل مستدام",
          a: "دلوقتي مع كونتكت، تقدر تحقق خططك الزراعية بسهولة. بنقدملك حلول تمويل مصممة للصوب الزراعية وأحواض الثروة السمكية بدون أي عبء مالي. نمو أسرع، إنتاجية أعلى، حلول صديقة للبيئة. ازرع صح، واحصد أكتر. ممكن تقدم أونلاين أو تزور أقرب فرع لكونتكت.",
        },
      ],
    },
    why_product: {
      title: " ليه تختار كونتكت للتمويل الأخضر؟",
      subtitle: "",
      description:
        " في كونتكت، باعتبارنا من الروّاد في التمويل الأخضر، بنمكّن الأفراد والشركاتة.من تبنّي حلول مستدامة تحقق قيمة طويلة المدى وتأثير وطني حقيقي ليه كونتكت هو الشريك المثالي في رحلتك نحو الاستدامة؟",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/whyGreen.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/supportGreenIcon.svg",
          text: "دعم حقيقي لاقتصاد مصر الأخضر",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/expertise-icon.svg",
          text: "خبرة موثوقة في التمويل المستدام",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "شبكة معتمدة من أفضل الشركات المنفذة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "توفير ذكي وعائد طويل المدى",
        },
      ],
    },

    faq: {
      title: "أسئلة شائعة عن تقسيط الطاقة الشمسية للمنازل",
      items: [
        {
          q: "يعني إيه تمويل أخضر؟",
          a: `
      التمويل الأخضر هو نوع من التمويل بيدعم المشروعات الصديقة للبيئة، عشان نحافظ على الموارد الطبيعية ونقلل من التأثير السلبي على البيئة.
      <br/><br/>
      التمويل الأخضر من كونتكت بيساعد الأفراد والشركات إنهم يستثمروا في حلول الطاقة المتجددة زي تركيب الألواح الشمسية، أو يطوروا الممارسات الزراعية زي أنظمة الري الحديثة، الصوب الزراعية، مزارع الأسماك، وتربية المواشي. وده كله من خلال خطط سداد مرنة وموافقات سريعة، عشان تقدر تطور شغلك وتفيد البيئة في نفس الوقت.
      `,
        },
        {
          q: "مين يقدر يستفيد من التمويل الأخضر من كونتكت؟",
          a: `
      التمويل الأخضر هو الحل المثالي لأي حد عايز يستثمر في حلول صديقة للبيئة ومستدامة.
      <br/><br/>
      سواء كنت مزارع وعايز تطور نظام الري عندك، صاحب مشروع وبتجهز صوبة زراعية، أو حتى عايز تركب ألواح شمسية في بيتك، التمويل الأخضر من كونتكت بيخلي الحياة المستدامة أسهل وفي متناول الجميع وبأسعار مناسبة.
      `,
        },
        {
          q: "إزاي أقدم على التمويل الأخضر من كونتكت؟",
          a: `
      عشان تقدم على التمويل الأخضر من كونتكت، هنحتاج منك:
      <ul style="margin-top: 10px;">
        <li><strong>بطاقتك الشخصية:</strong> بطاقة الرقم القومي أو جواز السفر.</li>
        <li><strong>إثبات الدخل:</strong> مفردات مرتب للموظفين أو كشف حساب بنكي لأصحاب الأعمال الحرة.</li>
        <li><strong>تفاصيل طلب التمويل:</strong>
          <ul style="margin-top: 5px;">
            <li>قيمة التمويل المطلوبة (لحد 3 مليون جنيه).</li>
            <li>مدة التقسيط اللي تناسبك (لحد 5 سنين).</li>
          </ul>
        </li>
      </ul>
      فريقنا ممكن يطلب منك معلومات إضافية حسب نوع التمويل اللي بتقدّم له.
      <br/><br/>
      تقدر تتواصل معانا في أي وقت، وإحنا هنساعدك خطوة بخطوة في كل المتطلبات والإجراءات!
      `,
        },
        {
          q: "إيه هي خطوات تركيب الألواح الشمسية مع كونتكت؟",
          a: `
      التقديم على تركيب الألواح الشمسية مع كونتكت سهل، وتقدر تختار الطريقة اللي تناسبك!
      <br/><br/>
      <strong>الاختيار الأول: التقديم أونلاين</strong>
      <ul style="margin-top: 10px;">
        <li>ادخل على صفحة التمويل الأخضر من كونتكت.</li>
        <li>املأ النموذج: كل اللي محتاجه اسمك بالكامل، رقم الموبايل، والرقم القومي.</li>
        <li>هنكلمك فوراً: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم.</li>
        <li>الموافقة بتوصلك بسرعة: بنراجع طلبك ونرجعلك بالرد في أسرع وقت.</li>
        <li>اختار خطة التقسيط المناسبة ليك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال واتساب أو تطبيق كونتكت ناو.</li>
      </ul>
      <strong>الاختيار الثاني: التقديم من الفرع</strong>
      <p style="margin-top: 10px;">
     زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك من هنا.
      </p>
      `,
        },
      ],
    },

    outro:
      "الزراعة والطاقة النظيفة هما المستقبل اللي بنحلم بيه لينا ولأولادنا، وعشان كده كونتكت بتدعمهم من خلال منتجاتها التمويلية المبتكرة. لو كنت مهتم بالتمويل الأخضر، يبقى اتصل بينا النهاردة. لمعرفة المزيد من المعلومات والتفاصيل.",
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title1: "من خلال التمويل الأخضر ممكن ",
      title2: "تمول :",
      body: [
        "وحدات الطاقة الشمسية",
        "تطوير نظم الري",
        "الصوب الزراعية ",
        "تطوير وتجهيز مشروعات الزراعات الخندقية والأغطية البلاستيكية للأنفاق والصوب الزراعية ",
        "أحواض ومعدات الثروة السمكية",
        "عنابر ومعدات الثروة الداجنة",
        "عنابر ومعدات الثروة الحيوانية",
      ],
    },
  },
  insurance_page: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover.webp",
      color: "#282780",
      title1: "وساطة تأمينية",
      title2: "عيش مطّمن وأنت مأمن",
      description_indiv: ` كونتكت وساطة تأميــنيــة، مكان واحد يمكنك أن تجد فيه كل الخطط التأمينية المناسبة لشركتك. إذا كنت تختار خطط تأمين لمشروعك أو لشركتك فيمكنك الاعتماد على خدمات الوساطة التأمينية من كونتكت، لأننا نقدم لك كل الاختيارات من أفضل شركات التأمين في مصر في مكان واحد! يمكنك أن تجمع ما بين أكثر من خطة مختلفة من أكثر من مقدم خدمات تأمينية بحسب احتياجات شركتك في عرض واحد وتعاقد واحد معنا، مما يجعل اختيار الخطة المناسبة لشركتك أمر سهل مع كونتكت.`,
      description_comp: ` محتاج مكان واحد تقدر تأمن فيه على مشروعك أو شركتك، مع كونتكت تقدر تختار ما بين الباقات التأمينية المختلفة اللي بنوفرهالك من خلال أقوي شركات التأمين في مصر بأقل الأسعار وبأفضل مزايا تأمينية تناسب احتياجات الشركات والمؤسسات المختلفة.`,
    },
    subTitle: "تأمين الأفراد",
    section_a: [
      {
        img: "/family_insurance.svg",
        title: "تأمين عيلتك",
        points: [
          "تأمين طبي",
          "تأمين حياة",
          " حوادث شخصية",
          "كارت المزايا الطبية",
        ],
      },
      {
        img: "/home_insurance.svg",
        title: "تأمين بيتك",
        points: ["تأمين المنزل", "عطل الأجهزة وامتداد الضمان", "استبدال مفتاح"],
      },
      {
        img: "/car_insurance.svg",
        title: "تأمين عربيتك",
        points: [
          "تأمين سيارة",
          "تأمين الهلاك الكلي للسيارات (ملاكي / نقل)",
          "تأمين سيارات النقل",
          "تأمين أخطار الطريق",
          "تغطية استبدال المفتاح",
        ],
      },
      {
        img: "/travel_insurance.svg",
        title: "تأمين مشروعك",
        points: ["تأمين المشروعات الصغيرة"],
      },
    ],
  },
  watercraft: {
    id: 54,
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-main.png",
      color: "#27A9E1",
      title: "جاهز تنطلق؟",
      description: ` قدّم على تمويل مراكب أونلاين دلوقتي أو زور أقرب فرع لكونتكت، وفريقنا هيساعدك تبدأ مغامرتك البحرية على طول!`,
    },
    price_desc: "المركبة المائية – اليخوت – الجيت سكي ",
    price: "السعـــر",

    main_section: {
      titleLine1: "تمويل ",
      titleLine2: "المراكب",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-main.png",
      header: "استمتع بالموج مع تمويل المركبات من كونتكت!",
      description: "",
      paragraph2: `بتدور على رفاهية، ولحظات ما تتنسيش على المياه ؟ مع حلول تمويل مراكب من كونتكت، امتلاك مركبتك البحرية المفضلة بقى أسهل من أي وقت فات. لو عايز تمويل يخوت، تمويل جت سكي، أو تجهيز نفسك للكاياك، الرافتنج، الكايت سيرف، الباراسيلينج، التزلج على الميّة، أو حتى الغوص، إحنا جاهزين نغطي كل احتياجاتك.
معانا هتلاقي تمويل معدات بحرية وخيارات تقسيط مراكب وخطط تمويل بحرية تناسب أسلوب حياتك وميزانيتك. ومع متطلبات تمويل مراكب بسيطة وسهلة، كونتكت بتخلي حلم المغامرة البحرية يتحقق بسهولة ومرونة. استمتع بالراحة، الحرية، والإثارة، وإحنا جنبك طول الطريق.
`,
      buttonText: "قدم الآن",
      subtitle: "جاهز تنطلق؟",
    },
    product_program: {
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-second.png",
      title: "احسب اقساطك بسهولة مع كونتكت",
      paragraph: `تخطيط اقساطك بقى أسهل من أي وقت فات! استخدم حاسبة الأقساط أونلاين من كونتكت عشان تعرف اقساطك الشهرية لتمويل المراكب و تمويل معدات الرياضات المائية. كل اللي عليك تحط المبلغ، تختار خطة الدفع اللي تناسبك، و هتعرف قسطك الشهري فورا. الحاسبة بتساعدك تاخد قرار صح وتظبط ميزانيتك بسهولة، عشان تمشي في طريقك وانت مطمّن.
جرّب الحاسبة دلوقتي!
 خطط اقساطك في ثواني وشوف قد ايه سهل تمتلك مركبتك مع كونتكت.`,
      list: [],
    },
    third_section: {
      title: "ليه تختار كونتكت لتمويل المراكب؟",
      description: `مع كونتكت، امتلاك مركبتك البحرية بقى أسهل من أي وقت فات. بنقدملك خطط دفع مرنة لغاية 5 سنين، وتمويل يصل لـ 15 مليون جنيه، وكمان مقدم يبدأ من 20% بس. إجراءاتنا سريعة وبسيطة عشان تجربتك تكون من غير أي تعب أو مشاكل. وكمان بنقدملك تمويل للصيانة وتصليح المراكب، عشان تستمتع برحلتك البحرية أو جت سكي من غير قلق. كونتكت بتخلي تمويل المراكب والمعدات البحرية سهل، مريح، وبسعر مناسب ليك.`,
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/third-sec-watercraft.png",
    },

    why_product: {
      title: "",
      description: `استمتع بمزايا تمويل مرن وسهل يخليك تشتري كل انواع المركبات و معدات الرياضات المائية إللي نفسك فيها`,

      imageSrc: "",

      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "فترات سداد تصل إلى 5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل إلى 15 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/coin-icon.svg",
          text: "مقدم يبدأ من ٢٠ ٪",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/quality-icon.svg",
          text: "إمكانية تمويل مصاريف الصيانة والإصلاح",
        },
      ],
    },

    faq: {
      title: "الأسئلة الشائعة",
      items: [
        {
          q: "إيه مميزات تمويل مركبات ومعدات الرياضات المائية من كونتكت؟",
          a: `
          <p>تمويل مركبات ومعدات الرياضات المائية مع كونتكت فيه مزايا كتير:</p>
        <ul style="margin-top: 10px;">
          <li>خطط تمويل مرنة لحد 5 سنين.</li>
          <li>تمويل لحد 15 مليون جنيه.</li>
          <li>مقدم بسيط يبدأ من 20% بس.</li>
          <li>تمويل يشمل كمان مصاريف الصيانة والإصلاحات.</li>
          <li>وإجراءات سهلة وسريعة علشان تقضي وقتك في البحر مش في الورق!</li>
        </ul>
      `,
        },
        {
          q: "إزاي أقدّم على تمويل مركبات ومعدات الرياضات المائية من كونتكت؟ ",
          a: `
          <p>التقديم بسيط جدًا، وتقدر تختار الطريقة اللي تناسبك:</p>
 <ul style="margin-top: 10px;">
    <li><strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 5px;">
        <li>ادخل على صفحة تمويل مركبات ومعدات الرياضات المائية من كونتكت</li>
        <li>املأ الاستمارة القصيرة: الاسم بالكامل، رقم الموبايل، ورقم البطاقة</li>
        <li>هيتواصل معاك ممثل من كونتكت لتأكيد البيانات وطلب أي مستندات إضافية لو محتاج.</li>
        <li>بنراجع الطلبات بسرعة علشان تبدأ في أقرب وقت.</li>
        <li>اختار خطة التقسيط اللي تناسبك.</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a></li>
      </ol>
    </li>
    <li style="margin-top: 10px;"><strong>الاختيار الثاني: التقديم من الفرع</strong>
     <p>زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.</p>
  </ul>      `,
        },
        {
          q: "إيه المستندات المطلوبة للتقديم على تمويل مركبات ومعدات الرياضات المائية من كونتكت؟",
          a: `
        <p>كل اللي هنحتاجه منك في الأول هو بطاقة رقم قومي سارية.</p>
        <p>لما ممثلنا يتواصل معاك بعد تقديم الطلب، هيبلغك لو في أي مستندات إضافية مطلوبة حسب حالتك علشان نكمّل إجراءات التمويل بسهولة وبسرعة.</p>
      `,
        },
        {
          q: "أقدر أموّل إيه من خلال تمويل مركبات ومعدات الرياضات المائية من كونتكت؟ ",
          a: `
          <p>لو بتحب الرياضات والأنشطة المائية، تمويل مع كونتكت هيساعدك تجيب اللي بتحلم بيه بسهولة. تقدر تموّل أنواع كتير من المراكب والمعدات البحرية، زي:</p>
        <ul style="margin-top: 10px;">
        <li>يخوت ولنشات وجت سكي</li>
        <li>معدات الغطس والرافتينج والكاياك.</li>
        <li>معدات الكيت سيرفنج، التزلج على المية، والباراسيلينج.</li>
        <li>وأي معدات بحرية تانية محتاجها لمغامراتك.</li>
        </ul>
        <p>سواء بتدور على تمويل مراكب، تمويل جت سكي أو تمويل معدات الرياضات المائية، كونتكت بتقدملك خطط تمويل بحرية مرنة وتقسيط مريح يخليك تستمتع بالبحر من غير ضغط على ميزانيتك.</p>
      `,
        },
        {
          q: "إيه الشروط المطلوبة علشان أقدر أقدم على تمويل مركبات ومعدات الرياضات المائية من كونتكت؟ ",
          a: `
          <p>الشروط بسيطة جدًا:</p>
          <ul>
          <li>السن يكون من 21 لحد 65 سنة.</li>
          <li>لازم يكون معاك بطاقة رقم قومي سارية.</li>
          </ul>
          <p>احنا بنخلّي كل حاجة سهلة وواضحة علشان تركّز على مغامرتك الجاية في البحر!</p>
      `,
        },
      ],
    },
    outro:
      "اتصل بينا وكونتكت هتساعدك في تمويل المركبات ومعدات الرياضات المائية اللي بتحبها وتبدأ المغامرة.",
  },
  motorcycle: {
    id: 55,
    cover: {
      color: "#DD6F5A",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/MotoFinanc.png",
      title: "جاهز تنطلق في رحلتك وتحقق حلمك؟",
      description: `ممكن تقدم اونلاين أو تزور أقرب فرع لكونتكت. وابدأ المشوار!`,
    },
    price_desc: "الموتوسيكل – الإسكوتر – الجولف كار",
    price: "السعـــر",

    outro:
      "كونتكت بتوفرلك طريقة سهلة ومريحة عشان تمتلك دراجة نارية أو سكوتر أو جولف كار أو بيتش باجي اللي بتحلم بيهم، وكمان بتوفرلك كل الملحقات اللي ممكن تحتاجها. اتصل بينا وهنوفرلك أكبر مبلغ تمويل وأسهل الإجراءات عشان تمتلك دراجـــتك في أسرع وقت.",
    main_section: {
      titleLine1: "تمويل",
      titleLine2: "موتوسيكلك",
      mainImage:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/MotoFinanc.png",
      header: "نفسك تنطلق على الطريق بحرية ",
      description:
        " مع حلول تمويل موتوسيكلك من كونتكت، موتوسيكلك الجديد أقرب مما تتخيل!",
      paragraph2:
        " لو حابب تقسط موتسيكل جديد، مستعمل ، أو حتى موديل كهربائي حديث, إحنا هنساعدك في كل الاحتمالات كونتكت كمان بتموّل سكوترات مستعملة، موتوسيكلات كهربائية، جولف كار وبيتش باجى.",
      buttonText: "قدّم اونلاين مع كونتكت.",
      subtitle: "مع كونتكت، الحرية بتبدأ من هنا",
    },
    why_product: {
      title: "خطة لكل راكب",
      subtitle: "الرحلة أسهل مع كونتكت",
      description:
        "كونتكت بتقدملك خطط تمويل مميزة للموتوسيكلات الجديدة أو المستعملة ، و كمان بتوفر تمويل الإسكوتر، موتوسيكل كهرباء أو غيرهم من الدراجات .",

      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/golf.png",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-icon.svg",
          text: "تمويل يصل ل4 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment-plans-icon.svg",
          text: "خطط سداد تصل ل5 سنوات",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/down-payment-icon.svg",
          text: " مقدم يبدأ من 20%",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/fast-hassle-icon.svg",
          text: "إجراءات سريعة وبسيطة",
        },
      ],
      note: "تمويل لجميع أنواع الدراجات النارية والكهربائية، والكروزر،البيتش باجي،عربيات الجولف،الإسكوتر البنزين، والإسكوتر الكهربائي",
    },
    ProductBrands: {
      title: "اختار موتوسيكل على ذوقك؛كونتكت بتمول كل الماركات",
      subtitle: " الموتوسيكل اللي تختاره، بتمويل مضمون من أفضل الماركات.",
      description: ` في كونتكت، بنقدملك تمويلات مرنة لجميع البراندات علشان تضمن الجودة، الأداء، وراحة البال.
في حالة كان سكوترعملي أو تقسيط موتوسيكلات كهرباء، وحتى تقسيط موتسكيلات مستعملة هنساعدك توصل للي نفسك فيه، بالشروط اللي تناسبك. احنا كمان بنوفر تقسيط على أشهر الماركات زي سوزوكي و كوازاكي و دايلم و كيمكو.
`,
      paragraph2: "مع كونتكت، حلمك على الطريق بيبدأ بثقة.",
      imageSrc:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ProductBrand.png",
    },
    why_contact: {
      title: "ليه تختار كونتكت لتمويل الموتوسيكل؟",
      subtitle: "فكّر على المدى البعيد وابدأ مشوارك بأذكى طريقة مع كونتكت.",
      description:
        "دلوقتي ومع حلول التمويل المميزة من كونتكت، امتلاك الموتوسيكل اللي بتحلم بيه بقى أسهل و اسرع ",
      iconsWithTexts: [
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/financing-white-icon.svg",
          text: " تمويل بقيمة تصل إلى 4 مليون جنيه",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/RepaymentIcon.svg",
          text: " خطط سداد مرنة ومصممة حسب احتياجك",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/SimpleHassleIcon.svg",
          text: " إجراءات تقديم بسيطة وسلسة",
        },
        {
          icon: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/AccessMotoIcon.svg",
          text: " وصول مباشر لأكبر شبكة معارض موتوسيكلات بالتقسيط معتمدة",
        },
      ],
    },
    faq: {
      title: "أسئلة شائعة عن تقسيط الموتوسيكلات",
      items: [
        {
          q: "إيه مميزات تقسيط موتوسيكل مع كونتكت؟",
          a: `
  مع كونتكت، تمويل الموتوسيكل بتاعك بقى سهل وبسيط! ودي شوية من المميزات اللي هتستمتع بيها:
  <ul style="margin-top: 10px;">
    <li>موافقة سريعة</li>
    <li>تمويل لحد 4 مليون جنيه، سواء كان الموتوسيكل جديد، مستعمل، أو حتى مستورد</li>
    <li>مقدم يبدأ من 20% بس</li>
    <li>خطط سداد مرنة لحد 5 سنين، علشان تدفع براحتك</li>
    <li>تمويل لكل أنواع المركبات: موتوسيكلات، سكوتر، بيتش باجي، عربيات جولف، وحتى الإكسسوارات</li>
    <li>تقدر كمان تضيف تأمين على الموتوسيكل علشان تركب وانت مطمن</li>
  </ul>
  `,
        },
        {
          q: "إزاي أقدم على تمويل دراجة نارية من كونتكت؟",
          a: `
  التقديم سهل، وتقدر تختار الطريقة اللي تناسبك!
  <ul style="margin-top: 10px;">
    <li><strong>الاختيار الأول: التقديم أونلاين</strong>
      <ol style="margin-top: 5px;">
        <li>ادخل على صفحة تمويل الدراجات النارية من كونتكت</li>
        <li>ملى النموذج: كل اللي محتاجه اسمك بالكامل، رقم الموبايل، والرقم القومي</li>
        <li>هنكلمك فوراً: أحد ممثلي كونتكت هيتواصل معاك لتأكيد البيانات وطلب أي أوراق إضافية لو لزم</li>
        <li>الموافقة بتوصلك بسرعة: بنراجع طلبك ونرجعلك بالرد في أسرع وقت</li>
        <li>اختار خطة التقسيط المناسبة ليك</li>
        <li>تابع وسدّد الأقساط بسهولة: من خلال <a href="https://api.whatsapp.com/send/?phone=20216177&text&type=phone_number&app_absent=0">واتساب</a> أو تطبيق <a href="https://play.google.com/store/apps/details?id=eg.contact">كونتكت ناو</a></li>
      </ol>
    </li>
    <li style="margin-top: 10px;"><strong>الاختيار الثاني: التقديم من الفرع</strong>
     <p>زور أقرب فرع ليك، وفريقنا هناك هيساعدك في كل خطوة!
تقدر تعرف أقرب فرع ليك <a href="https://contact.eg/our-branches">من هنا</a>.</p>
  </ul>
  `,
        },

        {
          q: "إيه الورق المطلوب عشان أقدم على تمويل موتوسيكل من كونتكت؟",
          a: `
  كل اللي هتحتاج تقدمه:
  <ol style="margin-top: 10px;">
    <li><strong>بطاقتك الشخصية:</strong> بطاقة الرقم القومي أو جواز السفر</li>
    <li><strong>إثبات الدخل:</strong> مفردات مرتب للموظفين أو كشف حساب بنكي لأصحاب الأعمال الحرة</li>
    <li><strong>تفاصيل طلب التمويل:</strong>
      <ul style="margin-top: 5px;">
        <li>مدة التقسيط اللي تناسبك (لحد 5 سنين)</li>
        <li>قيمة التمويل المطلوبة (لحد 4 مليون جنيه)</li>
        <li>تفاصيل موديل الموتوسيكل</li>
      </ul>
    </li>
  </ol>
  <p>فريقنا ممكن يطلب منك معلومات إضافية حسب نوع التمويل اللي بتقدّم له.  <a href="https://contact.eg/contact-us">تقدر تتواصل معانا في أي وقت،</a> وإحنا هنساعدك خطوة بخطوة في كل المتطلبات والإجراءات!</p>
  `,
        },

        {
          q: "إيه اللي ممكن أموله من خلال تمويل الموتوسيكلات من كونتكت؟",
          a: `
مع كونتكت، عندك فرصة تموّل حاجات أكتر بكتير من بس الدراجات النارية. التمويل بيشمل:  <ul style="margin-top: 10px;">
    <li>الدراجات النارية، الإسكوتر، العجلات الجبلية والعجل العادي</li>
    <li>عربيات الجولف والبيتش باجي</li>
    <li>المركبات بعجلتين أو تلاتة أو أربعة — سواء جديدة، مستعملة أو مستوردة</li>
    <li>الإكسسوارات والإضافات لمركبتك</li>
  </ul>
  ومع تمويل بيوصل لحد <strong>٤ مليون جنيه</strong>، تقدر تختار الموديل اللي يناسبك (حتى لو هاي اند!) وتضيف عليه كل المميزات اللي محتاجها.
  `,
        },
      ],
    },
  },
};
